const de = {
  common: {
    loading: "Laden...",
    save: "Speichern",
    saving: "Speichern...",
    saved: "Gespeichert",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    delete: "Löschen",
    edit: "Bearbeiten",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    send: "Senden",
    yes: "Ja",
    no: "Nein",
    error: "Fehler",
    success: "Erfolg",
    search: "Suchen",
    filter: "Filtern",
    all: "Alle",
    more: "Mehr",
    less: "Weniger",
    or: "oder",
    and: "und",
    premium: "Premium",
    basis: "Basis",
    continue: "Fortsetzen",
    start: "Starten",
    install: "Installieren",
    upgrade: "Upgrade",
    today: "Heute",
    yesterday: "Gestern",
    daysAgo: "Vor {days} Tagen",
  },

  nav: {
    dashboard: "Dashboard",
    tagebuch: "Tagebuch",
    coach: "Coach Sitzungen",
    sessions: "Sessions",
    hoerbuch: "Hörbuch",
    kompass: "Kompass",
    community: "Community",
    dokumente: "Dokumente",
    mikrobiom: "Mikrobiom",
    ernaehrung: "Ernährung",
    tagesroutine: "Tagesroutine",
    rezepte: "Rezepte",
    fortschritt: "Fortschritt",
    programme: "Programme",
    gamification: "Gamification",
    schlaf: "Schlaf",
    wearables: "Wearables",
    profil: "Profil",
    hilfe: "Hilfe & FAQ",
    feedback: "Feedback",
    logout: "Abmelden",
    demo: "Demo",
    willkommen: "Willkommen",
    admin: "Admin",
  },

  profil: {
    title: "Profil & Einstellungen",
    meinProfil: "Mein Profil",
    vorname: "Vorname",
    nachname: "Nachname",
    email: "E-Mail",
    geburtsdatum: "Geburtsdatum",
    speichern: "Speichern",
    gespeichert: "Gespeichert",
    bearbeiten: "Bearbeiten",
    abbrechen: "Abbrechen",
    paket: "Mein Paket",
    mitgliedSeit: "Mitglied seit",
    premiumPaket: "Premium-Paket",
    basisPaket: "Basis-Paket",
    stimme: "Stimme wählen",
    stimmeHinweis: "Wähle, wer dich als Coach begleitet und mit welcher Stimme.",
    sprache: "Sprache",
    spracheHinweis: "Wähle deine bevorzugte Sprache für die App.",
    spracheDeutsch: "Deutsch",
    spracheEnglisch: "Englisch",
    tutorial: "Tutorial",
    tutorialNeu: "Tutorial neu starten",
    faq: "Häufige Fragen",
    telegram: "Telegram verbinden",
    community: "Community Bot",
    benachrichtigungen: "Benachrichtigungen",
    abo: "Audio-Sessions Abo",
    profilbild: "Profilbild",
    profilbildAendern: "Profilbild ändern",
    profilbildLoeschen: "Profilbild löschen",
    passwortAendern: "Passwort ändern",
    kontoLoeschen: "Konto löschen",
  },

  dashboard: {
    willkommen: "Willkommen zurück, {name}!",
    tageszitat: "Tageszitat",
    fortschritt: "Dein Fortschritt",
    naechsteSession: "Nächste Session",
    checkin: "Check-In",
    checkinStarten: "Check-In starten",
    programme: "Deine Programme",
    empfehlungen: "Empfehlungen",
    heute: "Heute",
    tagesroutine: "Tagesroutine",
    news: "Neuigkeiten",
    greeting: "{greeting}, {name}.",
    greetingMorning: "Guten Morgen",
    greetingDay: "Guten Tag",
    greetingEvening: "Guten Abend",
    greetingNight: "Gute Nacht",
    greetingSubtitle: "Schön, dass du wieder da bist. Wie geht es dir heute?",
    greetingSubtitleNew: "Willkommen bei AYU. Lass uns gemeinsam starten.",
    phenotyp: "Dein Phänotyp",
    basedOnQuestionnaire: "Basierend auf deinem persönlichen Fragebogen",
    packagePremium: "AYU + DNA Mikrobiom",
    packageBasis: "AYU Basis",
    packageDescPremium: "Inkl. genetischer Darm-Mikrobiom-Analyse",
    packageDescBasis: "Persönlicher Gesundheitsplan",
    upgradeBtn: "Upgrade auf DNA",
    tagebuchEntries: "Einträge",
    tagebuchEntry: "Eintrag",
    coachSessions: "Sitzungen",
    coachSession: "Sitzung",
    aktiv: "Tage aktiv",
    aktivTag: "Tag aktiv",
    coachingStil: "Coaching-Stil",
    deinStil: "Dein Stil",
    stilAendern: "Tippen zum Ändern",
    tippDesTages: "Tipp des Tages",
    stimmungsverlauf: "Stimmungsverlauf",
    stimmungToWenig: "Zu wenig Daten",
    stimmungAufwaerts: "Aufwärts",
    stimmungAbwaerts: "Abwärts",
    stimmungStabil: "Stabil",
    stimmungGut: "Gut",
    stimmungOkay: "Okay",
    stimmungAusbaufaehig: "Ausbaufähig",
    weiterhören: "Weiterhören",
    hoerbuchStats: "Hörbuch-Statistiken",
    gehoert: "Gehört",
    fertig: "Fertig",
    fortschrittAvg: "Ø Fortschritt",
    hoerTage: "Hör-Tage",
    tagebuchWriteEntry: "Eintrag schreiben",
    tagebuchSubtitle: "Halte deine Gedanken fest. Schreib auf, was dich heute bewegt.",
    coachSubtitle: "Sprich mit Annam. Sie kennt deine Geschichte.",
    annamSessions: "Annam Sitzungen",
    startSession: "Sitzung starten",
    kompassTitle: "Kompass",
    kompassSubtitle: "Dein Gesundheitsüberblick — Empfehlungen und Fortschritte",
    aktivitaet: "Aktivität",
    checkinFaellig: "Check-In fällig",
    checkinErster: "Erster Check-In verfügbar",
    checkinSubtitle: "Erfasse deinen aktuellen Zustand für personalisierte Empfehlungen",
    checkinDaysAgo: "Letzter Check-In vor {days} Tagen — Zeit für ein Update",
    naechsterCheckin: "Nächster Check-In",
    verfuegbarIn: "Verfügbar in {days} Tagen — einmal pro Quartal",
    pwaInstallTitle: "AYU als App installieren",
    pwaInstallSubtitle: "Ein Tap — AYU direkt auf deinem Homescreen",
    pwaInstallFallback: "Füge AYU zu deinem Homescreen hinzu für schnellen Zugriff",
    pwaInstalled: "AYU wurde installiert!",
    iosStep1: "Tippe unten in Safari auf das Teilen-Symbol",
    iosStep2: 'Scrolle und tippe auf "Zum Home-Bildschirm"',
    iosStep3: 'Tippe oben rechts auf "Hinzufügen" — fertig!',
    iosFinalNote: "Danach öffnet sich AYU im Vollbild, wie eine echte App.",
    telegramNotConnected: "Noch nicht verbunden",
    telegramConnectBtn: "Mit Annam verbinden",
    telegramConnect: "Verbinden",
    telegramDisconnect: "Abbrechen",
    telegramSearch: "Suche in Telegram nach",
    telegramStep1: "Suche in Telegram nach @Ayu_health_bot",
    telegramStep2: "Schreibe /start",
    telegramStep3: "Gib den erhaltenen Code hier ein",
    telegramLinked: "Erfolgreich verbunden!",
    telegramLinkError: "Verknüpfung fehlgeschlagen",
    telegramConnectionError: "Verbindungsfehler",
    communityTelegram: "AYU Community — Telegram",
    communityExchange: "Austausch mit anderen AYU-Mitgliedern",
    communityHowTo: "So trittst du bei — 2 einfache Schritte:",
    communityStep1: "Klicke auf den Button unten — er öffnet den AYU Community Bot direkt in Telegram.",
    communityStep2: "Tippe auf START — dein Account wird automatisch verknüpft. Fertig!",
    communityOpenBot: "Community Bot in Telegram öffnen",
    communityConfirmJoined: "Bereits beigetreten? Hier bestätigen",
    communityFallback: "Falls der Link nicht funktioniert: Suche in Telegram nach @Ayu_community_bot",
    upgradeRedirecting: "Du wirst zur Kasse weitergeleitet...",
    upgradeError: "Fehler beim Upgrade",
    coachSitzungen: "Coach Sitzungen",
    coachingEmpathisch: "Einfühlsam",
    coachingDirekt: "Direkt",
    coachingFreundschaftlich: "Freundschaftlich",
    telegramVerbindeText: "Verbinde dein Konto mit Annam auf Telegram für tägliche Check-ins und Updates.",
  },

  coach: {
    title: "AYU Coach",
    neueSession: "Neue Sitzung",
    nachricht: "Was beschäftigt dich?",
    senden: "Senden",
    aufnahme: "Sprachaufnahme",
    verlauf: "Gesprächsverlauf",
    keineSessions: "Noch keine Sessions vorhanden.",
    sessionStarten: "Neue Session starten",
    sessionBeenden: "Session beenden",
    zusammenfassung: "Zusammenfassung",
    empfehlungen: "Empfehlungen",
    archiv: "Archiv",
    archivOeffnen: "Archiv öffnen",
    archivSchliessen: "Archiv schließen",
    vergangeneSession: "Du siehst eine vergangene {type}-Sitzung.",
    chatSitzung: "Chat",
    sprachSitzung: "Sprach",
    zurueckAktuell: "Zurück zur aktuellen Sitzung",
    zurueckAktuellerChat: "Zurück zum aktuellen Chat",
    diesen: "Diesen {type} fortsetzen",
    anrufFortsetzen: "Diesen Anruf fortsetzen",
    chatFortsetzen: "Diesen Chat fortsetzen",
    hierWeiterreden: "Hier weiterreden",
    hierWeiterchatten: "Chatten Sie hier weiter.",
    verlaufWirdGeladen: "Verlauf wird geladen...",
    verbindungsproblem: "Verbindungsproblem. Bitte versuche es erneut.",
    begleiter: "Dein persoenlicher Gesundheitsbegleiter — per Text oder Sprache",
    speakWith: "Mit {name} sprechen",
    voiceStart: "Echtzeit-Sprachgespräch starten",
    voice: "Stimme:",
    speaking: "Vorlesen stoppen",
    lastAnswer: "Letzte Antwort vorlesen",
    readAloud: "Vorlesen",
    stop: "Stoppen",
    loading: "Wird geladen...",
    styleQuestion: "Wie soll ich mit dir sprechen?",
    coachingStyleSuggestion: "Coaching-Stil-Vorschlag",
    fitForMe: "Passt zu mir",
    later: "Später",
    recordingRunning: "Aufnahme läuft... {duration}s",
    recognizing: "Sprache wird erkannt...",
    imageReady: "Bild bereit zum Senden",
    imageUploaded: "Hochgeladenes Bild",
    uploadImage: "Bild hochladen",
    speakNow: "Sprich jetzt..",
    imageQuestion: "Frage zum Bild stellen...",
    recordingStop: "Aufnahme stoppen & transkribieren",
    startVoice: "Spracheingabe starten",
    recordingCancel: "Aufnahme abbrechen",
    errorImageType: "Bitte wähle eine Bilddatei (JPG, PNG, WebP, GIF).",
    errorImageSize: "Bild zu groß. Maximum: 10 MB.",
    historyNote: "Annam kennt deine Geschichte und arbeitet mit dir. Verlauf wird gespeichert.",
    exerciseError: "Übung konnte nicht gestartet werden. Bitte versuche es erneut.",
    stopRecording: "Aufnahme stoppen",
    voiceInput: "Spracheingabe",
    archivAusblenden: "Archiv ausblenden",
    archivSelectMode: "Auswählen zum Löschen",
    archivSelectSessions: "Sitzungen auswählen",
    archivNSelected: "{n} ausgewählt",
    archivDeleteN: "{n} löschen?",
    archivNoSessions: "Noch keine vergangenen Sitzungen",
    archivRename: "Umbenennen",
    archivContinue: "Weiterführen",
    archivVoiceSession: "Sprachsitzung",
    archivSession: "Sitzung",
    archivDeleteWarning1: "Diese Sitzung wird dauerhaft gelöscht.",
    archivDeleteWarningN: "Diese Sitzungen werden dauerhaft gelöscht.",
  },

  tagebuch: {
    title: "Tagebuch",
    neuerEintrag: "Neuer Eintrag",
    eintragSchreiben: "Was geht dir heute durch den Kopf? Schreib einfach drauflos — hier ist dein Raum...",
    datum: "Datum",
    stimmung: "Stimmung",
    energie: "Energie",
    schlaf: "Schlaf",
    ernaehrung: "Ernährung",
    bewegung: "Bewegung",
    notizen: "Notizen",
    speichern: "Eintrag speichern",
    keineEintraege: "Noch keine Einträge vorhanden.",
    subtitle: "Dein Raum fuer Gedanken, Gefuehle und Reflexionen",
    spruch: "Spruch",
    horoskop: "Horoskop",
    witz: "Witz",
    cortisol: "Cortisol-Senker des Tages",
    sternzeichenUnbekannt: "Dein Sternzeichen ist noch nicht bekannt.",
    geburtsdatumEingeben: "Geburtsdatum eingeben",
    uhr: "Uhr",
    wieGefuehlst: "Wie fühlst du dich?",
    super: "Super",
    gut: "Gut",
    okay: "Okay",
    meh: "Meh",
    schlecht: "Schlecht",
    eintragGespeichert: "Eintrag gespeichert",
    eintragGespeichertDesc: "Dein Tagebuch-Eintrag ist sicher aufbewahrt. Du kannst jetzt gehen — oder Annam um eine Rückmeldung bitten.",
    deinEintrag: "Dein Eintrag",
    coachingBitten: "Annam um Coaching bitten",
    annamDenkt: "Annam denkt nach...",
    inspiriereicht: "Oder lass dich inspirieren",
    orakel: "Orakel",
    mantra: "Mantra",
    antwortAnnam: "Antworte Annam...",
    keineMeldungen: "Keine Nachrichten in diesem Eintrag",
    mitAnnamSprechen: "Mit Annam über diesen Eintrag sprechen",
    laufenderEintrag: "Du hast einen laufenden Eintrag.",
    vorherigTag: "Vorheriger Tag",
    naechsterTag: "Nächster Tag",
    zurueckZuHeute: "Zurück zu Heute",
    eintragNum: "Eintrag {current} von {total}",
    vergangeneEintraege: "{count} vergangene Einträge",
    aufnahme: "Aufnahme... {duration}s",
    wirdErkannt: "Wird erkannt...",
    aufnehmenStoppen: "Aufnahme stoppen",
    aufnehmenStarten: "Spracheingabe",
    fehlerGespeichert: "Eintrag konnte nicht gespeichert werden. Bitte versuche es erneut.",
    fehlerCoaching: "Annam konnte gerade nicht antworten.",
    geburtsdatumTitle: "Dein Geburtsdatum",
    geburtsdatumDesc: "Für dein persönliches Tageshoroskop brauchen wir dein Geburtsdatum.",
    geburtsdatumLabel: "Geburtsdatum",
    geburtsdatumHinweis: "Dein Geburtsdatum wird nur für das Horoskop verwendet.",
    wirdGespeichert: "Wird gespeichert...",
    trigger: "Trigger",
  },

  kompass: {
    title: "AYU Kompass",
    subtitle: "Dein Phänotyp-Profil, Tagesempfehlungen und Gesundheitsüberblick auf einen Blick",
    dosha: "Dein Dosha-Profil",
    vata: "Vata",
    pitta: "Pitta",
    kapha: "Kapha",
    prakriti: "Prakriti",
    vikriti: "Vikriti",
    beschreibung: "Beschreibung",
    empfehlungen: "Empfehlungen",
    ernaehrung: "Ernährungs-Empfehlungen",
    lebensweise: "Lebensweise",
    phenotyp: "Dein AYU-Phänotyp",
    staerken: "Deine Stärken",
    typgerecht: "Typgerechte Empfehlungen",
    bewegung: "Bewegung",
    mental: "Mental",
    verteilung: "Phänotyp-Verteilung",
    mitTendenz: "mit Tendenz zum",
    keinPhenotypTitle: "Dein AYU-Phänotyp wartet",
    keinPhenotypDesc: "Beantworte den AYU-Fragebogen, um deinen persönlichen Phänotyp zu entdecken und individuelle Empfehlungen für Ernährung, Bewegung und mentale Balance zu erhalten.",
    fragebogenStarten: "Fragebogen starten",
    stimmungsverlauf: "Stimmungsverlauf",
    keineStimmung: "Noch keine Stimmungsdaten.",
    stimmungHint: "Nutze das Tagebuch, um deine Stimmung zu tracken.",
    aktivitaet: "Deine Aktivität",
    coach: "Coach",
    tageDabei: "Tage dabei",
    hinweis: "Der AYU Kompass zeigt dir eine Übersicht deiner Gesundheitsdaten. Je mehr du das Tagebuch und den Coach nutzt, desto genauer wird dein persönliches Gesundheitsbild. Deine Daten werden ausschließlich für deine persönliche Gesundheitsberatung verwendet.",
  },

  checkin: {
    title: "Täglicher Check-In",
    stimmung: "Wie ist deine Stimmung heute?",
    energie: "Wie ist dein Energielevel?",
    schlaf: "Wie hast du geschlafen?",
    ernaehrung: "Wie hast du dich ernährt?",
    verdauung: "Wie ist deine Verdauung?",
    kommentar: "Weitere Anmerkungen",
    abschicken: "Check-In abschicken",
    danke: "Danke für deinen Check-In!",
    gut: "Gut",
    mittel: "Mittel",
    schlecht: "Schlecht",
    frage: "Frage {current} von {total}",
    weiter: "Weiter",
    zurueck: "Zurück",
    abschliessen: "Check-In abschließen",
    ergebnis: "Dein Ergebnis",
    saveError: "Fehler beim Speichern. Bitte versuche es erneut.",
    abgeschlossen: "Check-In abgeschlossen",
    zustandErfasst: "Dein aktueller funktionaler Zustand wurde erfasst.",
    aktuellerZustand: "Dein aktueller Zustand",
    energieLabel: "Energie",
    verdauungLabel: "Verdauung",
    schlafLabel: "Schlaf",
    stressLabel: "Stress",
    emotionaleBalance: "Emotionale Balance",
    hautgesundheit: "Hautgesundheit",
    immunstaerke: "Immunstärke",
    fokusbereich: "Fokusbereich:",
    zumDashboard: "Zum Dashboard",
    sessionsStarten: "Sessions starten",
    mehrfachauswahl: "Mehrfachauswahl möglich",
  },

  sessions: {
    title: "Sessions",
    live: "Live-Gespräche",
    uebungen: "Chat-Übungen",
    verfuegbar: "Verfügbare Sessions",
    gestartet: "Session gestartet",
    premium: "Premium",
    basis: "Basis",
    unbegrenzt: "Unbegrenzt",
    sessionCount: "Sessions",
    basisKostenlos: "Basis-Sessions sind kostenlos verfügbar",
    basisSessions: "Basis-Sessions",
    personalisierteSessions: "Personalisierte Sessions",
    liveGespraeche: "Live-Gespräche",
    chatUebungen: "Chat-Übungen",
    gespraeche: "Gespräche",
    uebungenLabel: "Übungen",
    alleFreischalten: "Alle Sessions freischalten",
    paketeAnsehen: "Pakete ansehen",
    gratis: "Gratis",
    genutzt: "Genutzt",
    limitErreicht: "Monatliches Session-Limit erreicht",
    paketUpgraden: "Paket upgraden",
    kostenlos: "Kostenlos",
    wirdErstellt: "Wird erstellt...",
    premiumFreischalten: "Premium freischalten",
    starten: "Starten",
    sessionBeendet: "Session beendet",
    dauer: "Dauer:",
    nochmalStarten: "Nochmal starten",
    zurueckDashboard: "Zurück zum Dashboard",
    sek: "Sek.",
    min: "Min.",
    zahlung: "Zahlung erfolgreich!",
    freigeschaltet: "Sessions freigeschaltet!",
    checkoutAbgebrochen: "Checkout abgebrochen",
    premiumSessions: "Premium-Sessions",
    demoModus: "Im Demo-Modus nicht verfügbar",
    beratungBuchen: "Kostenlose Beratung buchen",
    schliessen: "Schließen",
    ayuPremium: "AYU Premium freischalten",
    flexibel: "Flexibel & fair",
    wasPassiert: "Was passiert gerade?",
    zurück: "Zurück",
    uebungenSessions: "Übungen & Sessions",
    headerDesc: "Meditation, Atemübungen, Yoga Nidra und mehr — wähle eine Session passend zu deinem Bedürfnis",
    basisKostenlosDesc: "Mit einem AYU-Abo (Starter, Medium oder Unlimited) erhältst du Zugang zu allen personalisierten Sessions — individuell auf deinen AYU-Phänotyp abgestimmt.",
    limitErreichtCount: "Monatliches Session-Limit erreicht ({used}/{limit})",
    limitErreichtDesc: "Du hast alle Sessions dieses Monats genutzt. Upgrade dein Paket für mehr Sessions oder warte bis zum nächsten Monat. Basis-Sessions bleiben weiterhin kostenlos verfügbar.",
    liveDesc: "Echte Gespräche mit AYU — er hört zu, reagiert und begleitet dich individuell.",
    chatDesc: "Interaktive Übungen, die AYU Schritt für Schritt im Chat mit dir durchführt.",
    keineKategorie: "Keine Sessions in dieser Kategorie gefunden.",
    paketeDesc: "Wähle ein Paket und erhalte sofort Zugang zu allen personalisierten Sessions. Jedes Abo beinhaltet sämtliche Übungen — keine versteckten Kosten.",
    zahlungDesc: "Dein Zugang wird in wenigen Sekunden aktiviert...",
    freigeschaltetDesc: "Du kannst jetzt alle personalisierten Sessions nutzen.",
    checkoutAbgebrochenDesc: "Du kannst jederzeit erneut ein Paket wählen.",
    bitteMelden: "Bitte melde dich zuerst an.",
    weiterleitungStripe: "Weiterleitung zu Stripe...",
    checkoutFehler: "Fehler beim Checkout",
    sessionGestartetDesc: "Die geführte Session beginnt...",
    sessionLimitErreicht: "Session-Limit erreicht",
    limitUpgradeDesc: "Upgrade dein Paket oder warte bis zum nächsten Monat. Basis-Sessions sind weiterhin kostenlos.",
    gratisGenutzt: "Gratis-Session bereits genutzt",
    gratisGenutztDesc: "Schalte ein Abo frei, um diese Session erneut zu nutzen.",
    sessionBereit: "Session bereit!",
    sessionBereitDesc: "Deine personalisierte Session wird abgespielt.",
    personalisiertePremium: "Personalisierte Premium-Session",
    fehlerErstellung: "Fehler bei der Erstellung",
    phaseChecking: "Session wird geprüft...",
    phaseText: "Text wird generiert...",
    phaseAudio: "Audio wird generiert...",
    phaseFertig: "Session ist bereit!",
    phaseFehler: "Fehler",
    phaseCheckingDesc: "Wir prüfen, ob deine Session bereits verfügbar ist.",
    phaseTextDesc: "Der personalisierte Text wird für dich erstellt.",
    phaseAudioDesc: "Der Text wird in eine professionelle Sprachaufnahme umgewandelt.",
    phaseFertigDesc: "Deine Session wird jetzt abgespielt...",
    wasPassiertText: "AYU erstellt eine personalisierte {title}-Session nur für dich. Der Text wird von KI generiert und anschließend in eine professionelle Audio-Anleitung umgewandelt. Dieser Vorgang dauert in der Regel 30–60 Sekunden.",
    approxTime: "ca. 30–60 Sek.",
    demoBody: "Im Demo-Modus kannst du dir die Sessions ansehen. Für den vollen Zugang buche eine kostenlose Beratung.",
    ayuPremiumDesc: "Erhalte Zugang zu allen personalisierten Sessions — individuell auf deinen AYU-Phänotyp abgestimmt.",
    beliebt: "Beliebt",
    starterWaehlen: "Starter wählen",
    mediumWaehlen: "Medium wählen",
    unlimitedWaehlen: "Unlimited wählen",
    flexibelDesc: "Jederzeit kündbar oder downgradebar. Du kannst dein Paket monatlich anpassen — ohne Mindestlaufzeit, ohne versteckte Kosten.",
    stepText: "Text",
    stepAudio: "Audio",
    stepFertig: "Fertig",
    katAlle: "Alle",
    katBasis: "Basis",
    katAtem: "Atem",
    katEntspannung: "Entspannung",
    katMeditation: "Meditation",
    katEnergetisch: "Energetisch",
    katIntensiv: "Intensiv",
  },

  programme: {
    title: "Programme",
    aktuell: "Aktuelles Programm",
    abgeschlossen: "Abgeschlossene Programme",
    verfuegbar: "Verfügbare Programme",
    starten: "Programm starten",
    fortsetzen: "Fortsetzen",
    woche: "Woche",
    lektion: "Lektion",
    abgeschlossenAm: "Abgeschlossen am",
    katalog: "Programm-Katalog",
    katalogSubtitle: "Lerne Schritt für Schritt in wöchentlichen Modulen — von Ernährung bis Stressmanagement",
    wochen: "{n} Wochen",
    aufgaben: "{n} Aufgaben",
    wocheVon: "Woche {current} von {total}",
    aktiv: "Aktiv",
    dna: "DNA",
    abgeschlossenBadge: "Abgeschlossen",
    upgradeLink: "Upgrade auf AYU + DNA",
    jetztKaufen: "Jetzt kaufen für {price} €",
    kostenlosBeiUpgrade: "Kostenlos beim Upgrade auf AYU + DNA",
    weiterMachen: "Weiter machen",
    detailsAnsehen: "Details ansehen",
    keineProgramme: "Keine Programme verfügbar",
    keineProgrammeDesc: "Neue Programme werden bald hinzugefügt.",
    zurueckKatalog: "Zurück zum Katalog",
    aufgabenVon: "{completed} von {total} Aufgaben",
    jetzEinschreiben: "Jetzt einschreiben",
    pausieren: "Pausieren",
    fortsetzenBtn: "Fortsetzen",
    wochenplan: "Wochenplan",
    aktuelleWoche: "Aktuelle Woche",
    lernziele: "Lernziele dieser Woche",
    audio: "Audio:",
    rezept: "Rezept:",
    bonus: "Schließe dieses Programm ab und erhalte {points} Prana-Punkte!",
    programmAbgeschlossen: "Programm abgeschlossen!",
    glueckwunsch: "Herzlichen Glückwunsch! Du hast alle Aufgaben gemeistert.",
    aufgabeErledigt: "Aufgabe erledigt!",
    fortschrittLabel: "Fortschritt: {percent}%",
    speichernFehler: "Fehler beim Speichern",
    eingeschrieben: "Du bist jetzt eingeschrieben!",
    eingeschriebenDesc: "Dein Programm beginnt heute. Viel Erfolg!",
    einschreibungFehler: "Einschreibung fehlgeschlagen",
    eingeschriebenJetzt: "Eingeschrieben! Dein Programm beginnt jetzt.",
    programmFortgesetzt: "Programm fortgesetzt!",
    programmPausiert: "Programm pausiert. Du kannst jederzeit weitermachen.",
    programmAbgebrochen: "Programm abgebrochen.",
    programmNichtGefunden: "Programm nicht gefunden.",
    checkoutRedirecting: "Du wirst zur Kasse weitergeleitet...",
    checkoutFehler: "Fehler beim Erstellen der Checkout-Session",
    minLabel: "Min.",
    aktualisierungFehler: "Fehler beim Aktualisieren",
  },

  rezepte: {
    title: "Deine Rezepte",
    suche: "Rezept suchen...",
    kategorien: "Kategorien",
    favoriten: "Favoriten",
    alle: "Alle Rezepte",
    fruehstueck: "Frühstück",
    mittagessen: "Mittagessen",
    abendessen: "Abendessen",
    snack: "Snack",
    getraenk: "Getränk",
    zutaten: "Zutaten",
    zubereitung: "Zubereitung",
    portionen: "Portionen",
    dauer: "Dauer",
    speichern: "Rezept speichern",
    gespeichert: "Gespeichert",
    subtitle: "Entdecke ayurvedische Gerichte passend zu deiner Konstitution",
    sammlungen: "Sammlungen",
    neueSammlung: "Neue Sammlung",
    sammlungErstellt: "Sammlung erstellt!",
    sammlungUmbenannt: "Sammlung umbenannt!",
    sammlungGeloescht: "Sammlung gelöscht",
    sammlung: "Zu Sammlung",
    teilen: "In Community teilen",
    pdfDrucken: "Als PDF drucken",
    loeschen: "Löschen",
    bearbeiten: "Rezept bearbeiten",
    ayurvHinweis: "Ayurvedischer Hinweis",
    rezeptAnzeigen: "Rezept anzeigen →",
    rezeptGenerieren: "Rezept generieren",
    eigenesRezept: "Eigenes Rezept",
    eigenesRezeptDesc: "Füge dein Lieblingsrezept manuell hinzu",
    hinzufuegen: "Hinzufügen",
    rezeptAusФoto: "Rezept aus Foto",
    rezeptWirdErkannt: "Rezept wird erkannt...",
    fotoAuswaehlen: "Foto auswählen",
    eigenesHinzufuegen: "Eigenes Rezept hinzufügen",
    neuesRezeptErstellt: "Neues Rezept wurde erstellt!",
    rezeptGespeichert: "\"{title}\" wurde gespeichert!",
    rezeptFotoImport: "\"{title}\" wurde aus dem Foto importiert!",
    rezeptAktualisiert: "Rezept aktualisiert!",
    rezeptGeloescht: "Rezept gelöscht",
    rezeptGeteilt: "Rezept wurde in der Community geteilt!",
    fehlerTeilen: "Fehler beim Teilen: {msg}",
    fehlerBildLesen: "Fehler beim Lesen des Bildes.",
    bildTypFehler: "Bitte wähle ein Bild (JPG, PNG oder WebP).",
    bildZuGross: "Das Bild ist zu groß (max. 10 MB).",
    titelEingeben: "Bitte gib einen Titel ein.",
    nochKeinRezept: "Noch keine Rezepte.",
    nochKeinRezeptCollection: "Noch keine Rezepte in \"{name}\". Füge Rezepte über das Drei-Punkte-Menü hinzu.",
    nochKeinFavoriten: "Noch keine Favoriten. Klicke auf das Herz-Symbol, um Rezepte zu markieren.",
    nochKeinNachricht: "Noch keine Sammlungen erstellt",
    titel: "Titel",
    kurzbeschreibung: "Kurze Beschreibung",
    kategorie: "Kategorie",
    zubereitungszeit: "Zubereitungszeit",
    notizHinweis: "Notiz / Hinweis",
    min: "Min",
    speichernBtn: "Speichern",
    aenderungenSpeichern: "Änderungen speichern",
    wirdGespeichert: "Wird gespeichert...",
    wirdErstellt: "Wird erstellt...",
    generieren: "Generieren",
    abbrechen: "Abbrechen",
    wuensche: "Wünsche? z.B. 'ohne Milch', 'schnell'...",
    sammlungLoeschenBestaetigung: "Sammlung wirklich löschen?",
    sammelnNamePlaceholder: "Name der Sammlung...",
    erstellen: "Erstellen",
    teilenKurz: "Teilen",
    fotoDesc: "Fotografiere ein Rezept aus einem Kochbuch, Magazin oder handgeschriebene Notizen.",
    nochKeinRezeptHauptseite: "Noch keine Rezepte. Generiere, erstelle oder importiere dein erstes Rezept!",
    rezeptSingular: "Rezept",
    rezeptPlural: "Rezepte",
    vonAnzahl: "von {total}",
    eineProZeile: "(eine pro Zeile)",
    einSchritt: "(ein Schritt pro Zeile)",
    alle_label: "Alle",
  },

  fortschritt: {
    title: "Dein Fortschritt",
    uebersicht: "Übersicht",
    woche: "Diese Woche",
    monat: "Dieser Monat",
    gesamt: "Gesamt",
    subtitle: "Verfolge deine Gewohnheiten, Ziele und persönliche Entwicklung",
    deineSerien: "Deine Serien",
    deineZiele: "Deine Ziele",
    neuesZiel: "Neues Ziel",
    neuesZielErstellen: "Neues Ziel erstellen",
    schnellstart: "Schnellstart-Vorlagen:",
    eigenesZiel: "Oder eigenes Ziel:",
    zielTitel: "Ziel-Titel...",
    tageLabel: "Tage",
    zielErstellen: "Ziel erstellen",
    pausiert: "Pausiert",
    erreicht: "Erreicht ({n})",
    heuteAktiv: "Heute aktiv",
    rekord: "Rekord:",
    gesamtLabel: "Gesamt:",
    tage: "Tage",
    zielErreicht: "Ziel erreicht!",
    heuteErledigt: "Heute erledigt",
    heuteAbhaken: "Heute abhaken",
    fortsetzen: "Fortsetzen",
    neuesZielErstellt: "Neues Ziel erstellt!",
    herzlichen: "Herzlichen Glückwunsch! Ziel abgeschlossen.",
    fortschrittGespeichert: "Fortschritt gespeichert!",
    zielGeloescht: "Ziel gelöscht",
    keinZielBeschreibung: "Erstelle dein erstes Ziel, um deinen Fortschritt zu verfolgen.",
    ayuPfadWie: "Wie funktioniert der AYU-Pfad?",
    ayuPfadErklärung: "Prana-Punkte, Streaks, Badges & Level erklärt",
    nochKeineSerien: "Noch keine Serien. Nutze Tagebuch, Coach oder Sessions um deine erste Serie zu starten!",
    ersteZielErstellen: "Erstes Ziel erstellen",
    allesBadgesLevel: "Alle Badges & Level-Details ansehen",
  },

  gamification: {
    title: "Dein AYU-Pfad",
    punkte: "Prana-Punkte",
    abzeichen: "Abzeichen",
    level: "Level",
    streak: "Serie",
    naechstesBadge: "Nächstes Abzeichen",
    subtitle: "Dein persönlicher Gesundheitsweg — Punkte, Abzeichen & Fortschritt",
    uebersicht: "Übersicht",
    verlauf: "Verlauf",
    challenges: "Challenges",
    zuNaechstemLevel: "% zum nächsten Level",
    prana: "Prana",
    score: "Score",
    badges: "Badges",
    soFunktioniert: "So funktioniert dein AYU-Pfad",
    verdienteAbzeichen: "Verdiente Abzeichen ({n})",
    alleAbzeichen: "Alle Abzeichen",
    verdient: "Verdient",
    aktivesChallenges: "Aktive Challenges",
    vergangenesChallenges: "Vergangene Challenges",
    erledigt: "erledigt",
    erledigtLabel: "Erledigt",
    abgelaufen: "Abgelaufen",
    pranaVerlauf: "Prana-Punkte Verlauf",
    ayuScoreVerlauf: "AYU Score Verlauf",
    aktuell: "Aktuell",
    tagebuchEintrag: "Tagebuch-Eintrag:",
    coachSitzung: "Coach-Sitzung:",
    tagesroutineLabel: "Tagesroutine:",
    meditation: "Meditation:",
    rezeptGekocht: "Rezept gekocht:",
    communityBeitrag: "Community-Beitrag:",
    nochKeinePunkte: "Noch keine Punkte gesammelt",
    nochKeinePunkteDesc: "Starte mit einem Tagebuch-Eintrag oder einer Coach-Sitzung!",
    ayuPfad7Level: "AYU-Pfad (7 Level)",
  },

  schlaf: {
    title: "Schlaftracker",
    tracking: "Schlaf-Tracking",
    analyse: "Schlafanalyse",
    empfehlungen: "Schlaf-Empfehlungen",
    subtitle: "Erfasse und analysiere deinen Schlaf — dein Schlafmuster fließt direkt ins Coaching ein",
    eintragsFormular: "Eintrag",
    eintragsBearbeiten: "Eintrag bearbeiten",
    neuerEintrag: "Neuer Eintrag",
    vorhandenHinweis: "Du hast für diesen Tag bereits einen Eintrag. Du kannst ihn aktualisieren.",
    wieGeschlafen: "Wie hast du geschlafen?",
    datum: "Datum",
    eingeschlafen: "Eingeschlafen",
    aufgewacht: "Aufgewacht",
    wieErholt: "Wie erholt fühlst du dich?",
    einschlafen: "Einschlafen",
    nachtsAufgewacht: "Nachts aufgewacht",
    traeumeErinnert: "Träume erinnert",
    notizen: "Notizen (optional)",
    notizenPlaceholder: "z.B. Koffein am Abend, Stress, Sport...",
    aktualisieren: "Aktualisieren",
    speichern: "Speichern",
    letzte14: "Letzte 14 Tage",
    avQualitaet: "Ø Qualität",
    avSchlafdauer: "Ø Schlafdauer",
    eintraege: "Einträge",
    zuWenigDaten: "Zu wenig Daten",
    qualitaetsverlauf: "Qualitätsverlauf",
    besteNacht: "Beste Nacht",
    schlechtesteNacht: "Schlechteste Nacht",
    coachingEinfliessen: "Dein Schlaf fließt ins Coaching ein",
    coachingEinfliessenDesc: "Annam berücksichtigt deine Schlafdaten in Coaching-Sessions und kann dir personalisierte Empfehlungen für besseren Schlaf geben.",
    wearableIntegration: "Wearable-Integration",
    wearableDesc: "Verbinde dein Wearable für automatisches Schlaf-Tracking mit HRV, Tiefschlaf-Phasen und mehr.",
    demnächst: "Demnächst verfügbar",
    letzteEintraege: "Letzte Einträge",
    eintraegLoeschen: "Eintrag löschen",
    eintraegAktualisiert: "Eintrag aktualisiert",
    schlafEintragGespeichert: "Schlaf-Eintrag gespeichert",
    eintraegGeloescht: "Eintrag gelöscht",
    bitteMeldeAn: "Bitte melde dich an.",
    sofort: "Sofort",
    schnell: "Schnell",
    normal: "Normal",
    schwer: "Schwer",
    sehrSchwer: "Sehr schwer",
    sehrSchlecht: "Sehr schlecht",
    schlecht: "Schlecht",
    okay: "Okay",
    gut: "Gut",
    sehrGut: "Sehr gut",
    erschoepft: "Erschöpft",
    muede: "Müde",
    erholt: "Erholt",
    vollerEnergie: "Voller Energie",
  },

  wearables: {
    title: "Wearables",
    verbinden: "Gerät verbinden",
    daten: "Gesundheitsdaten",
    sync: "Synchronisieren",
    subtitle: "Verbinde dein Wearable mit Annam für automatisches Tracking und personalisiertes Coaching basierend auf deinen biometrischen Daten.",
    baldVerfuegbar: "Bald verfügbar",
    integrationen: "Wearable-Integrationen kommen bald",
    integrationenDesc: "Wir arbeiten an nahtlosen Integrationen mit den beliebtesten Gesundheits-Wearables. Deine Schlaf-, Stress- und HRV-Daten werden automatisch in dein AYU-Coaching einfließen — für noch präzisere und personalisierte Empfehlungen.",
    warteliste: "Auf der Warteliste",
    benachrichtige: "Benachrichtige mich",
    wartelisteN: "Du bist auf {n} Warteliste eingetragen.",
    wartelistenN: "Du bist auf {n} Wartelisten eingetragen.",
    soFunktioniert: "So wird es funktionieren",
    step1Title: "Verbinden",
    step1Desc: "Verbinde dein Wearable mit einem Klick über die offizielle API.",
    step2Title: "Synchronisieren",
    step2Desc: "Schlaf-, HRV- und Stress-Daten werden automatisch und sicher übertragen.",
    step3Title: "Personalisieren",
    step3Desc: "Annam nutzt deine biometrischen Daten für noch genauere Empfehlungen.",
    datenschutz: "Deine Gesundheitsdaten werden verschlüsselt übertragen und ausschließlich für dein persönliches Coaching verwendet. Du kannst die Verbindung jederzeit trennen.",
    bereitsWarteliste: "Du bist bereits auf der Warteliste!",
    benachrichtigtBald: "Du wirst benachrichtigt, sobald die Integration verfügbar ist!",
    fehlerEintragen: "Fehler beim Eintragen. Bitte versuche es erneut.",
    fehlerAustragen: "Fehler beim Austragen. Bitte versuche es erneut.",
    entfernt: "Du wurdest von der Warteliste entfernt.",
    ayuIntegration: "AYU Integration",
    datenFliessen: "Daten fließen automatisch in dein AYU-Coaching ein.",
  },

  tagesroutine: {
    title: "Tagesroutine",
    morgen: "Morgenroutine",
    abend: "Abendroutine",
    aufgaben: "Aufgaben",
    mittag: "Mittagsroutine",
    schritte: "Schritte",
    startzeiten: "Startzeiten anpassen",
    startzeitenHinweis: "Passe die Startzeiten an deinen Tagesrhythmus an — z.B. bei Nachtdienst oder Spätaufsteher",
    zuruecksetzen: "Zurücksetzen",
    morgenLabel: "Morgen",
    mittagLabel: "Mittag",
    abendLabel: "Abend",
    uhr: "Uhr",
    kraeuterEmpfehlungen: "Kräuter-Empfehlungen",
    dosierung: "Dosierung:",
    neuGenerieren: "Neue Routine generieren",
    wirdAktualisiert: "Wird aktualisiert...",
    erstelltAm: "Erstellt am {date}",
    keinePlan: "Noch keine Tagesroutine erstellt",
    keinePlanDesc: "Lass dir eine personalisierte Tagesroutine erstellen — basierend auf deinem Phänotyp, deinen Gesundheitsdaten und der aktuellen Jahreszeit.",
    erstellen: "Tagesroutine erstellen",
    wirdErstellt: "Wird erstellt...",
    routineErstellt: "Deine neue Tagesroutine wurde erstellt!",
    erstellenFehler: "Fehler beim Erstellen: {msg}",
    zeitZurueckgesetzt: "Zeiten auf Standard zurückgesetzt",
    wieRoutine: "Wie findest du deine Routine?",
    routineLabel: "{season}-Routine",
  },

  hoerbuch: {
    title: "Hörbuch",
    kapitel: "Kapitel",
    abspielen: "Abspielen",
    pausieren: "Pausieren",
    fortschritt: "Fortschritt",
    weiterhören: "Weiterhören",
    abgeschlossen: "Abgeschlossen",
    gratis: "Gratis",
    aktiv: "Aktiv",
    gehoert: "gehört",
    gehoertLabel: "Gehört",
    freischalten: "Vollständiges Hörbuch freischalten",
    jetztKaufen: "Jetzt kaufen",
    sofortVerfuegbar: "Sofort verfügbar",
    dauerhafterZugang: "Dauerhafter Zugang",
    professionell: "Professionell eingesprochen",
    einmaligerKauf: "Einmaliger Kauf",
    offlineModus: "Offline-Modus",
    alleOffline: "Alle Kapitel offline verfügbar",
    kapitelGespeichert: "{n} von {m} Kapiteln gespeichert",
    loeschen: "Löschen",
    alleHerunterladen: "Alle herunterladen",
    laedt: "Lädt...",
    kapitelWerdenGespeichert: "Kapitel werden für Offline-Nutzung gespeichert...",
    premiumZugang: "Premium-Zugang",
    freigeschaltet: "Freigeschaltet",
    lesezeichen: "Lesezeichen",
    notizen: "Notizen",
    kiSummary: "KI-Summary",
    statistik: "Statistik",
    export: "Export",
    sleep: "Sleep",
    timerAbbrechen: "Timer abbrechen",
    minuten: "{n} Minuten",
    deineLesezeichen: "Deine Lesezeichen",
    deineNotizen: "Deine Notizen",
    notizEingeben: "Notiz eingeben...",
    speichern: "Speichern",
    keineNotizen: "Noch keine Notizen...",
    kiZusammenfassung: "KI-Zusammenfassung",
    kernpunkte: "Kernpunkte",
    kiHinweis: "Lass dir eine KI-Zusammenfassung des Kapitels erstellen",
    zusammenfassungGenerieren: "Zusammenfassung generieren",
    wirdErstellt: "Wird erstellt...",
    hoerbuchStatistiken: "Deine Hörbuch-Statistiken",
    avFortschritt: "Ø Fortschritt",
    hoerTage: "Hör-Tage",
    meistGehoert: "Meistgehört:",
    kapitelLabel: "Kapitel",
    nKapitel: "{n} Kapitel",
    nVonMGratis: "{n} von {m} gratis",
    wenigerAnzeigen: "Weniger anzeigen",
    alleKapitelAnzeigen: "Alle {n} Kapitel anzeigen",
    allesBereitsCached: "Alle Kapitel sind bereits offline verfügbar.",
    kapitelWerdenGeladen: "{n} Kapitel werden heruntergeladen...",
    cacheClearedToast: "Offline-Cache geleert.",
    sleepTimerAbgelaufen: "Sleep-Timer abgelaufen — Wiedergabe pausiert.",
    sleepTimerGesetzt: "Sleep-Timer: {n} Minuten",
    zusammenfassungErstellt: "Zusammenfassung erstellt",
    zusammenfassungFehler: "Fehler bei der Zusammenfassung",
    nochKeineExportDaten: "Noch keine Notizen, Lesezeichen oder Zusammenfassungen zum Exportieren.",
    notizenExportiert: "Notizen exportiert!",
    lesezeichenGespeichert: "Lesezeichen gespeichert",
    lesezeichenGeloescht: "Lesezeichen gelöscht",
    notizGespeichert: "Notiz gespeichert",
    notizAktualisiert: "Notiz aktualisiert",
    notizGeloescht: "Notiz gelöscht",
    weiterleitungKasse: "Du wirst zur Kasse weitergeleitet...",
    checkoutFehler: "Fehler beim Erstellen der Checkout-Session",
    bitteMelden: "Bitte melde dich zuerst an.",
    erfolgreichGekauft: "Hörbuch erfolgreich gekauft! Alle Kapitel sind jetzt freigeschaltet.",
    kaufAbgebrochen: "Kauf abgebrochen.",
    nurVollversion: "Dieses Kapitel ist nur in der Vollversion verfügbar.",
    vollversionBeschreibung: "Kaufe das Hörbuch für 9,90 € um alle Kapitel freizuschalten.",
    kaufenAction: "Kaufen",
    purchaseDesc: "Alle {n} Kapitel — über {total} Minuten Wissen über Ayurveda, Genetik und deinen persönlichen Gesundheitsweg.",
    buchMeta: "Von Annam & Christopher Hanfstein · {n} Kapitel · ~{total} Minuten",
    ueberBuch: "Über das Buch",
    ueberBuchDesc: "Entdecke, wie die jahrtausendealte Weisheit des Ayurveda mit moderner Genetik und Epigenetik zu einem revolutionären Gesundheitsansatz verschmilzt. Annam und Christopher Hanfstein zeigen dir, warum ein personalisierter Weg der Schlüssel zu nachhaltiger Gesundheit ist.",
    keineNotizenHinweis: "Noch keine Notizen. Starte die Wiedergabe und schreibe deine Gedanken auf.",
    summariesVon: "{n} von {m} Kapiteln zusammengefasst",
    nochKeineStatistiken: "Noch keine Statistiken. Starte ein Kapitel, um deine Hör-Statistiken zu sehen.",
    kapitelPausieren: "{title} pausieren",
    kapitelAbspielen: "{title} abspielen",
    featureProfessionell: "Professionell",
    featureProfessionellDesc: "KI-Stimme in Studioqualität",
    featureKapitelDesc: "Über {total} Min Inhalt",
    featureDauerhaft: "Dauerhaft",
    featureDauerhaftDesc: "Einmal kaufen, immer hören",
    offlineVerfuegbar: "Offline verfügbar",
    lesezeichenLoeschen: "Lesezeichen löschen",
    bearbeiten: "Bearbeiten",
  },

  community: {
    title: "Community",
    nachrichten: "Nachrichten",
    kanal: "Kanal",
    senden: "Senden",
    keineNachrichten: "Noch keine Nachrichten",
    nachrichtLoeschen: "Nachricht löschen?",
    unwiderruflich: "Diese Nachricht wird unwiderruflich gelöscht.",
    abbrechen: "Abbrechen",
    loeschen: "Löschen",
    telegramBeitreten: "Telegram Community beitreten",
    communityBotOeffnen: "Community Bot öffnen",
    telegramVerbunden: "Telegram verbunden",
    botOeffnen: "Bot öffnen",
    ersteNachricht: "Sei die erste Person, die schreibt",
    neueNachricht: "1 neue Nachricht",
    neueNachrichten: "{n} neue Nachrichten",
    bildBereit: "Bild bereit zum Senden",
    beschreibung: "Beschreibung...",
    schreibEtwas: "Schreib etwas...",
    respektvoll: "Sei respektvoll und unterstützend.",
    bearbeiten: "Bearbeiten",
    loeschenAdmin: "Löschen (Admin)",
    subtitle: "Tausche dich mit der AYU-Community aus",
  },

  dokumente: {
    title: "Meine Dokumente",
    hochladen: "Dokument hochladen",
    keineDoc: "Noch keine Dokumente hochgeladen.",
    analysieren: "Analysieren",
    subtitle: "Lade Therapieberichte, Laborbefunde und andere Gesundheitsdokumente hoch",
    typWaehlen: "Dokumenttyp wählen",
    hierziehen: "Datei hierher ziehen oder klicken",
    formate: "PDF, TXT, JPG, PNG, DOCX — max. 10 MB",
    wirdHochgeladen: "Wird hochgeladen und analysiert...",
    hochgeladeneLabel: "Hochgeladene Dokumente ({n})",
    keineDocHilfe: "Deine Dokumente helfen AYU, dich besser zu verstehen",
    typNichtUnterstuetzt: "Dateityp nicht unterstützt. Bitte PDF, TXT, JPG, PNG oder DOCX verwenden.",
    zuGross: "Datei zu groß. Maximum: 10 MB.",
    wirdAnalysiert: "Wird analysiert...",
    analyseFehler: "Analyse fehlgeschlagen — Dokument wurde trotzdem gespeichert.",
    loeschenAria: "Dokument löschen",
    gesundheitsbericht: "Gesundheitsbericht",
    laborbefund: "Laborbefund",
    ernaehrungsplan: "Ernährungsplan",
    rezept: "Rezept",
    sonstiges: "Sonstiges",
    uploadFehler: "Upload fehlgeschlagen",
    subtitleCoaching: "Lade Therapieberichte, Arztbriefe oder Laborergebnisse hoch — AYU nutzt sie für personalisiertes Coaching.",
  },

  mikrobiom: {
    title: "Mikrobiom-Analyse",
    analyse: "Mikrobiom-Analyse",
    ergebnisse: "Ergebnisse",
    empfehlungen: "Empfehlungen",
    premium: "Premium-Feature",
    subtitle: "Deine persönliche Darm-Mikrobiom-Auswertung — von Annam analysiert und auf deinen Phänotyp abgestimmt.",
    nurDNA: "Nur im DNA-Paket verfügbar",
    nurDNADesc: "Die Mikrobiom-Analyse ist ein exklusives Feature des AYU + DNA Mikrobiom Pakets. Unser Team erstellt deine persönliche KI-gestützte Auswertung, die deinen Phänotyp noch präziser verfeinert.",
    dasErwartet: "Das erwartet dich",
    upgradeBtn: "Upgrade auf AYU + DNA Mikrobiom",
    upgradePreis: "Upgrade für nur 500 € — der Differenzbetrag zu deinem bestehenden Paket.",
    wartenLaborergebnisse: "Wir warten auf deine Laborergebnisse",
    wartenDesc: "Sobald dein Mikrobiom-Testbericht vom Labor eingetroffen ist, wird unser Team die Analyse erstellen und hier für dich bereitstellen. Du wirst benachrichtigt, sobald deine Auswertung fertig ist.",
    analyseAbgeschlossen: "Analyse abgeschlossen",
    deineAuswertung: "Deine Mikrobiom-Auswertung",
    ganzeBesprechen: "Ganze Analyse mit AYU Coach besprechen",
    befundeBesprechen: "Befunde mit AYU Coach besprechen",
    empfehlungenBesprechen: "Empfehlungen mit AYU Coach besprechen",
    phenotypBesprechen: "Phänotyp-Relevanz mit AYU Coach besprechen",
    besprechen: "Besprechen",
    wichtigsteBefunde: "Wichtigste Befunde",
    empfehlungenFuer: "Empfehlungen für dich",
    phenotypRelevanz: "Phänotyp-Relevanz",
    phenotypRelevanzMikrobiom: "Phänotyp-Relevanz aus Mikrobiom",
    detaillierteAnalyse: "Detaillierte Analyse",
    extrahierteDaten: "Extrahierte Daten",
    phenotypVerfeinern: "Meinen Phänotyp mit Mikrobiom-Daten verfeinern",
    phenotypWirdVerfeinert: "Phänotyp wird verfeinert...",
    phenotypVerfeinertErfolgreich: "Dein Phänotyp wurde erfolgreich verfeinert!",
    phenotypVerfeinertDesc: "Die Mikrobiom-Daten fließen jetzt in dein Profil ein. Schau auf dem Dashboard nach deinem aktualisierten Ergebnis.",
    naechstesMikrobiom: "Empfehlung: Nächstes Mikrobiom",
    mikrobiomFaellig: "Empfehlung: Neues Mikrobiom fällig",
    analyseErstellt: "Analyse erstellt am {date}",
    datenquellen: "Basierend auf {n} Datenquellen",
    upgradeRedirecting: "Du wirst zur Kasse weitergeleitet...",
    upgradeFehler: "Fehler beim Upgrade",
    lockedBullet1: "KI-Analyse deines Mikrobiom-Berichts",
    lockedBullet2: "Phänotyp-Verfeinerung mit Mikrobiom-Daten",
    lockedBullet3: "Personalisierte Ernährungsempfehlungen",
    lockedBullet4: "1.900+ Mikrobiom-Positionen analysiert",
    anbieter: "Anbieter: {value}",
    unbekannt: "Nicht erkannt",
    diversitaet: "Diversität: {n}/100",
    statusGut: "Gut",
    statusAuffaellig: "Auffällig",
    statusKritisch: "Kritisch",
    phenotypVerfeinertToast: "Phänotyp verfeinert: {from} → {to}",
    phenotypBestaetigt: "Phänotyp bestätigt: {name}",
    verfeinernFehler: "Verfeinerung fehlgeschlagen",
    seitEmpfohlen: "Seit {date} empfohlen — bitte neuen Test durchführen lassen.",
    abEmpfohlen: "Ab {date} empfohlen für optimale Verlaufskontrolle.",
    diversitaetsindex: "Diversitätsindex",
    schluesselBakterien: "Schlüsselbakterien",
    entzuendungsmarker: "Entzündungsmarker",
    kurzkettFettsaeuren: "Kurzkettige Fettsäuren",
    auffaelligkeiten: "Auffälligkeiten",
  },

  ernaehrung: {
    title: "Ernährungsprofil",
    profil: "Mein Ernährungsprofil",
    praeferenzen: "Ernährungs-Präferenzen",
    allergien: "Allergien & Unverträglichkeiten",
    speichern: "Profil speichern",
    subtitle: "Erfasse Vorlieben, Unverträglichkeiten und Ernährungsgewohnheiten — dein Coach passt Empfehlungen und Rezepte daran an",
    vonAngaben: "{filled} von {total} Angaben ausgefüllt",
    vollstaendig: "Vollständig! Dein Coach hat jetzt ein detailliertes Ernährungsbild.",
    lebensmittelPraeferenzen: "Lebensmittel-Präferenzen",
    bewerteLebensmittel: "Bewerte jedes Lebensmittel: Magst du es (Ja), magst du es nicht (Nein), oder ist es dir egal (Neutral)?",
    ernaehrungsfrequenz: "Ernährungsfrequenz",
    wieOft: "Wie oft isst du die folgenden Lebensmittelgruppen pro Woche?",
    ja: "Ja",
    nein: "Nein",
    neutral: "Neutral",
    taeglich: "Täglich",
    dreiBisSechsmal: "3-6x pro Woche",
    einsBisZweimal: "1-2x pro Woche",
    nie: "Nie / fast nie",
    gespeichert: "Ernährungsprofil gespeichert",
    gespeichertDesc: "Deine Lebensmittel-Präferenzen wurden aktualisiert.",
    fehlerSpeichern: "Fehler beim Speichern",
    profilSpeichern: "Ernährungsprofil speichern",
  },

  dinacharya: {
    title: "Deine Tagesroutine",
    morgen: "Morgenroutine",
    abend: "Abendroutine",
    empfehlungen: "Empfohlene Aktivitäten",
    mittag: "Mittagsroutine",
    subtitle: "Dinacharya — Hake Morgen-, Mittag- und Abendroutinen ab und baue gesunde Gewohnheiten auf",
    schritte: "{n} Schritte",
    startzeiten: "Startzeiten anpassen",
    startzeitenHinweis: "Passe die Startzeiten an deinen Tagesrhythmus an — z.B. bei Nachtdienst oder Spätaufsteher",
    zuruecksetzen: "Zurücksetzen",
    morgenLabel: "Morgen",
    mittagLabel: "Mittag",
    abendLabel: "Abend",
    uhr: "Uhr",
    keinePlan: "Noch keine Tagesroutine erstellt",
    keinePlanDesc: "Lass dir eine personalisierte Tagesroutine erstellen — basierend auf deinem Phänotyp, deinen Gesundheitsdaten und der aktuellen Jahreszeit.",
    erstellen: "Tagesroutine erstellen",
    wirdErstellt: "Wird erstellt...",
    kraeuterEmpfehlungen: "Kräuter-Empfehlungen",
    wieRoutine: "Wie findest du deine Routine?",
    neuGenerieren: "Neue Routine generieren",
    wirdAktualisiert: "Wird aktualisiert...",
    erstelltAm: "Erstellt am {date}",
    routineErstellt: "Deine neue Tagesroutine wurde erstellt!",
    erstellenFehler: "Fehler beim Erstellen: {msg}",
    zeitZurueckgesetzt: "Zeiten auf Standard zurückgesetzt",
    zeitGeaendert: "{label} startet jetzt um {time} Uhr",
    routineLabel: "{season}-Routine",
    dosierung: "Dosierung:",
  },

  onboarding: {
    title: "Willkommen bei AYU",
    subtitle: "Lass uns gemeinsam deinen persönlichen Gesundheitsplan erstellen.",
    weiter: "Weiter",
    zurueck: "Zurück",
    abschliessen: "Abschließen",
    frage: "Frage {current} von {total}",
    fortschritt: "Fortschritt",
    auswerten: "Auswerten",
    laden: "Laden...",
    deinPhenotyp: "Dein AYU-Phänotyp",
    basiertAufAntworten: "Basierend auf deinen Antworten haben wir deinen persönlichen Gesundheitstyp bestimmt.",
    konfidenz: "Konfidenz",
    hoch: "Hoch",
    mittel: "Mittel",
    niedrig: "Niedrig",
    topPhenotypen: "Top Phänotypen",
    zweiInEins: "2-in-1 Phänotyp:",
    zeigstMerkmale: "Du zeigst zusätzlich starke Merkmale des",
    mehrfachauswahl: "Mehrfachauswahl möglich",
    deinAntwort: "Deine Antwort...",
    bitterGenauer: "Bitte genauer beschreiben...",
    niedrigLabel: "Niedrig",
    hochLabel: "Hoch",
    telegramVerbinden: "Telegram verbinden",
    telegramOptional: "Verbinde dich mit Telegram für tägliche Check-ins und Community-Austausch.",
    optional: "(Optional)",
    annamOeffnen: "Annam öffnen",
    telegramHinweis: "Öffnet Telegram → Tippe START → Gib den Code in der App unter Profil ein",
    communityBeitreten: "Community beitreten",
    communityHinweis: "Öffnet Telegram → Tippe START → Account wird automatisch verknüpft",
    dashboardOeffnen: "Mein AYU-Dashboard öffnen",
    ueberspringen: "Überspringen — später verbinden",
    pwaTitle: "AYU auf deinem Homescreen",
    pwaSubtitle: "Greife jederzeit schnell auf AYU zu — wie eine echte App.",
    sofortzugriff: "Sofortzugriff",
    sofortzugriffDesc: "Ein Tap auf dem Homescreen — direkt in AYU",
    vollbild: "Vollbild-Erlebnis",
    vollbildDesc: "Ohne Browser-Leiste — sieht aus wie eine echte App",
    keinDownload: "Kein Download nötig",
    keinDownloadDesc: "Kein App Store, kein Speicherplatz — sofort bereit",
    iosAnleitung: "So geht's auf dem iPhone:",
    iosSchritt1: "Tippe unten in Safari auf das Teilen-Symbol",
    iosSchritt2: 'Scrolle und tippe auf "Zum Home-Bildschirm"',
    iosSchritt3: 'Tippe oben rechts auf "Hinzufügen" — fertig!',
    iosGemacht: "Folge den Schritten oben!",
    appInstalliert: "AYU wurde installiert!",
    verstanden: "Verstanden, habe es gemacht!",
    appInstallieren: "AYU App installieren",
    soGehtEs: "So geht's:",
    browserMenue: "Öffne das Browser-Menü (⋮ oben rechts)",
    startbildschirm: 'Tippe auf "Zum Startbildschirm hinzufügen"',
    ueberspringenSpaeter: "Überspringen — später installieren",
    ja: "Ja",
    nein: "Nein",
    neutral: "Neutral",
    von: "Von",
    bis: "Bis",
    secondaryMerkmale: "Du zeigst zusätzlich starke Merkmale des \"{name}\" ({system}).",
  },

  auth: {
    anmelden: "Anmelden",
    abmelden: "Abmelden",
    registrieren: "Registrieren",
    email: "E-Mail",
    passwort: "Passwort",
    passwortVergessen: "Passwort vergessen?",
    anmeldenBtn: "Jetzt anmelden",
    willkommen: "Willkommen bei AYU",
    loginFehler: "Login fehlgeschlagen",
    abmeldenBestaetigen: "Möchtest du dich wirklich abmelden?",
    willkommenZurueck: "Willkommen zurück",
    kontoErstellen: "Konto erstellen",
    passwortZuruecksetzen: "Passwort zurücksetzen",
    neuesPasswort: "Neues Passwort wählen",
    loginSubtitle: "Melde dich an, um deinen persönlichen Gesundheitsplan zu sehen",
    registerSubtitle: "Erstelle dein AYU-Konto für personalisierte Gesundheit",
    forgotSubtitle: "Gib deine E-Mail ein, um dein Passwort zurückzusetzen",
    resetSubtitle: "Wähle ein neues Passwort für dein AYU-Konto",
    vorname: "Vorname",
    nachname: "Nachname",
    passwortMinLength: "Mindestens 8 Zeichen",
    linkSenden: "Link senden",
    passwortAendern: "Passwort ändern",
    zurueckZumLogin: "Zurück zum Login",
    bereitsKonto: "Bereits ein Konto? Anmelden",
    nochKeinKonto: "Noch kein Konto? Jetzt registrieren",
    neuBeiAyu: "Neu bei AYU?",
    kontoErstellenHint: "Erstelle in 30 Sekunden dein kostenloses Konto und starte deinen persönlichen Gesundheitsplan.",
    jetzt: "Jetzt Konto erstellen",
    wasErwartet: "Was dich nach der Anmeldung erwartet",
    soGehtEs: "So geht es nach der Anmeldung weiter:",
    schritt1: "Kurzer Fragebogen — damit Annam dich kennenlernt",
    schritt2: "Dein Dashboard wird eingerichtet",
    schritt3: "Starte dein erstes Gespräch mit Annam",
    datensicherheit: "Deine Daten sind sicher. Wir nutzen Verschlüsselung und speichern Passwörter nur als Hash.",
    ungueltig: "Ungültige E-Mail oder Passwort",
    passwortZuKurz: "Passwort muss mindestens 8 Zeichen haben",
    registrierungFehler: "Registrierung fehlgeschlagen. Ist die E-Mail bereits vergeben?",
    resetLinkGesendet: "Falls ein Konto mit dieser E-Mail existiert, erhältst du einen Link zum Zurücksetzen.",
    passwortGeaendert: "Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.",
    linkUngueltig: "Dieser Link ist ungültig oder abgelaufen.",
    neuesPasswortLabel: "Neues Passwort",
    platzhalterEmail: "deine@email.de",
    annamTitle: "Annam",
    annamDesc: "Dein persönlicher KI-Coach, der deine Geschichte kennt und dich begleitet.",
    sprachCoach: "Sprach-Coach",
    sprachCoachDesc: "Sprich in Echtzeit mit Annam — wie ein Gespräch mit einer guten Freundin.",
    tagebuchFeature: "Tagebuch",
    tagebuchFeatureDesc: "Halte deine Gedanken, Gefühle und Fortschritte fest — privat und sicher.",
    communityFeature: "Community",
    communityFeatureDesc: "Tausche dich mit anderen aus, die einen ähnlichen Weg gehen.",
  },

  hilfe: {
    title: "Hilfe & Support",
    subtitle: "Fragen zu AYU? Frag den KI-Assistenten oder stöbere in den häufigen Fragen — wir helfen dir gerne",
    chatTab: "Chat",
    faqTab: "FAQ",
    kontaktTab: "Kontakt",
    soNutzt: "So nutzt du AYU am besten",
    kontaktTitle: "Kontaktiere uns",
    kontaktSubtitle: "Unser Support-Team hilft dir gerne bei allen Fragen weiter.",
    emailLabel: "E-Mail",
    telefonLabel: "Telefon",
    telefonZeiten: "Mo–Fr, 9–17 Uhr",
    schnelleHilfe: "Schnelle Hilfe",
    schnelleHilfeDesc: "Nutze den Chat-Assistenten für sofortige Antworten zu den meisten Fragen.",
    zumChat: "Zum Chat-Assistenten",
    akuteKrise: "Akute Krise?",
    step1Title: "Tagebuch täglich nutzen",
    step1Desc: "Auch 5 Minuten reichen. Regelmäßigkeit ist wichtiger als Länge.",
    step2Title: "Annam für tiefere Themen",
    step2Desc: "Wenn du ein Thema wirklich durcharbeiten möchtest, nutze Annam.",
    step3Title: "Sei ehrlich mit dir selbst",
    step3Desc: "Annam funktioniert am besten, wenn du offen bist. Alles bleibt vertraulich.",
    faqWieStarten: "Wie starte ich mit Annam?",
    faqWieStartenAntwort: "Nach der Registrierung füllst du den Onboarding-Fragebogen aus (ca. 15 Minuten). Basierend auf deinen Antworten wird dein persönlicher AYU-Phänotyp bestimmt und dein individueller Gesundheitsplan erstellt.",
    faqPhenotyp: "Was ist mein AYU-Phänotyp?",
    faqPhenotypAntwort: "AYU arbeitet mit 12 menschlichen Phänotypen in 5 Clustern. Dein Phänotyp beschreibt deine individuelle körperliche und mentale Konstitution. Du findest dein Ergebnis im Kompass-Bereich der App.",
    faqAnnam: "Wie nutze ich Annam?",
    faqAnnamAntwort: "Annam ist deine persönliche KI-Gesundheitsberaterin. Du kannst per Text oder Sprache mit ihr kommunizieren. Sie kennt deinen Phänotyp und gibt dir personalisierte Empfehlungen für Ernährung, Bewegung und Achtsamkeit.",
    faqTagebuch: "Wie funktioniert das Tagebuch?",
    faqTagebuchAntwort: "Im Tagebuch kannst du täglich deine Stimmung, Ernährung und Aktivitäten festhalten. Annam analysiert deine Einträge und gibt dir personalisierte Tipps. Je regelmäßiger du schreibst, desto besser werden die Empfehlungen.",
    faqSessions: "Was sind die Audio-Sessions?",
    faqSessionsAntwort: "Die Sessions sind geführte Audio-Übungen für Meditation, Atemtechniken und Entspannung. 5 Basis-Sessions sind kostenlos enthalten. Mit einem Premium-Paket erhältst du Zugang zu personalisierten Sessions.",
    faqDokumente: "Kann ich Dokumente hochladen?",
    faqDokumenteAntwort: "Ja! Im Dokumente-Bereich kannst du Laborbefunde, Arztberichte und andere Gesundheitsdokumente hochladen. Annam kann diese bei der Beratung berücksichtigen (Premium-Feature).",
    faqCommunity: "Wie funktioniert die Community?",
    faqCommunityAntwort: "In der Community kannst du dich mit anderen AYU-Nutzern austauschen. Es gibt verschiedene Kanäle für Themen wie Rezepte, Erfahrungen und allgemeine Diskussionen.",
    faqDaten: "Sind meine Daten sicher?",
    faqDatenAntwort: "Ja, deine Daten werden verschlüsselt gespeichert und nach höchsten Sicherheitsstandards geschützt. Wir geben keine persönlichen Daten an Dritte weiter. Du kannst dein Konto und alle Daten jederzeit löschen.",
  },

  feedback: {
    title: "Feedback",
    subtitle: "Teile deine Erfahrung mit uns",
    kategorie: "Kategorie wählen",
    freude: "Freude",
    freudeDesc: "Was gefällt dir besonders gut? Teile deine positiven Erfahrungen",
    anmerkung: "Anmerkung",
    anmerkungDesc: "Verbesserungsvorschlag, Idee oder allgemeiner Hinweis",
    fehlfunktion: "Fehlfunktion",
    fehlfunktionDesc: "Etwas funktioniert nicht wie erwartet",
    fehlfunktionKritisch: "Fehlfunktion kritisch",
    fehlfunktionKritischDesc: "App nicht nutzbar oder Datenverlust",
    betroffeneSeite: "Betroffene Seite",
    kurzbeschreibung: "Kurzbeschreibung",
    detailliert: "Detaillierte Beschreibung",
    screenshot: "Screenshot hochladen",
    absenden: "Feedback senden",
    pflichtfelder: "Bitte fülle alle Pflichtfelder aus",
    seitePflicht: "Bitte wähle die betroffene Seite aus",
    bildZuGross: "Bild zu groß (max. 5 MB)",
    sendeError: "Fehler beim Senden",
    dankeFreude: "Danke für dein positives Feedback!",
    dankeAnmerkung: "Danke für deine Anmerkung!",
    dankeFehler: "Fehlermeldung gesendet!",
    weiteresFeedback: "Weiteres Feedback senden",
    zurueck: "Zurück zur App",
    allgemein: "Allgemein / Übergreifend",
    anderesSeite: "Andere Seite...",
    optional: "(optional)",
    seitePflichtLabel: "Betroffene Seite",
    seiteAuswaehlen: "Seite auswählen...",
    sonstSeite: "Welche Seite? (z.B. /app/...)",
    kurzbeschreibungLabel: "Kurzbeschreibung",
    detailliertLabel: "Detaillierte Beschreibung",
    screenshotOptional: "Screenshot",
    klickeOderZiehe: "Klicke hier oder ziehe ein Bild hierher",
    maxDateigroesse: "Max. 5 MB (JPG, PNG)",
    screenshotVorschau: "Screenshot-Vorschau",
    abbrechen: "Abbrechen",
    meldungSenden: "Meldung senden",
    dankeTitle: "Danke für dein Feedback!",
    dankePositivTitle: "Danke für dein Feedback!",
    dankeFehlerTitle: "Vielen Dank!",
    dankePositivDesc: "Dein Feedback hilft uns, AYU noch besser zu machen. Wir freuen uns über jede Rückmeldung!",
    dankeFehlerDesc: "Deine Meldung wurde erfolgreich gesendet. Unser Team wird sich darum kümmern.",
    weiteresFeedbackBtn: "Weiteres Feedback",
    zurueckHilfe: "Zurück zur Hilfe",
    wasNachricht: "Was möchtest du uns mitteilen?",
    pflichtMarkierung: "*",
    shortPlaceholderFreude: "Was hat dir besonders gut gefallen? (max. 1 Satz)",
    shortPlaceholderAnmerkung: "Was ist dein Vorschlag oder Hinweis? (max. 1 Satz)",
    shortPlaceholderFehler: "Was ist das Problem? (max. 1 Satz)",
    detailPlaceholderFreude: "Erzähl uns mehr: Was genau hat dich begeistert? Welche Funktion, welches Erlebnis?",
    detailPlaceholderAnmerkung: "Beschreibe deine Idee genauer: Was würdest du dir wünschen? Wie stellst du es dir vor?",
    detailPlaceholderFehler: "Beschreibe das Problem genauer: Was hast du gemacht? Was ist passiert? Was hast du erwartet?",
    feedbackTitle: "Feedback",
    feedbackSubtitle: "Dein Feedback hilft uns, AYU besser zu machen — ob Freude, Idee oder Fehlermeldung",
  },

  landing: {
    nav: {
      wasIstAyu: "Was ist AYU?",
      ayurveda: "Ayurveda",
      phaenotypen: "Phänotypen",
      ayuKompass: "AYU-Kompass",
      tagebuch: "Tagebuch",
      annam: "Annam",
      betreuer: "Betreuer",
      ayuErleben: "AYU erleben",
      bookStore: "Book Store",
      faq: "FAQ",
      jetztStarten: "Jetzt starten",
    },
    hero: {
      badge: "Tradition trifft Genetik",
      heading1: "Dein",
      heading2: "persönlicher",
      heading3: "Gesundheitsplan",
      subtitle: "5.000 Jahre Ayurveda-Weisheit, personalisiert durch moderne Wissenschaft. Entdecke deinen einzigartigen Phänotyp und lebe die Gesundheit, die zu dir passt.",
      ctaStart: "Jetzt Assessment starten",
      ctaLearnMore: "Mehr erfahren",
      annamTitle: "Annam Hanfstein",
      annamRole: "Gründerin & CEO – AYU-rveda",
    },
    stats: {
      menschen: "Menschen begleitet",
      jahre: "Jahre Ayurveda",
      phaenotypen: "Phänotypen",
      personalisiert: "Personalisiert",
    },
    wasIstAyu: {
      badge: "So funktioniert es",
      heading: "Was ist AYU?",
      description: "AYU ist dein personalisiertes Gesundheits- und Lifestyle-System. Es verbindet jahrtausendealte Ayurveda-Weisheit mit moderner Wissenschaft, um einen Gesundheitsplan zu erstellen, der wirklich zu dir passt.",
      step1Title: "Fragebogen ausfüllen",
      step1Desc: "In etwa 15 Minuten beantwortest du Fragen zu deiner Herkunft, deinem Lebensstil, deiner Ernährung und deinem mentalen Befinden.",
      step2Title: "Dein Phänotyp wird bestimmt",
      step2Desc: "Unser System analysiert deine Antworten und ordnet dich einem der 12 menschlichen Phänotypen zu – basierend auf Genetik, Kultur und Umwelt.",
      step3Title: "Dein persönlicher AYU entsteht",
      step3Desc: "Du erhältst einen individuellen Gesundheitsplan: Ernährung, Routinen, Bewegung, mentale Balance – alles auf dich zugeschnitten.",
    },
    ayurveda: {
      badge: "Die Grundlage",
      heading: "Was ist Ayurveda?",
      quote: '„Ayurveda ist mehr als eine Heilmethode – es ist eines der ältesten dokumentierten Systeme für Gesundheit und Lebensstil."',
      p1: "Ayurveda ist eines der ältesten dokumentierten Gesundheitssysteme der Menschheit. Seine Ursprünge reichen über 5.000 Jahre zurück und sind in der vedischen Kultur Indiens verwurzelt.",
      p2Text: "Während die westliche Medizin fragt",
      p2Western: "Wie entsteht Krankheit?",
      p2Text2: ", fragt Ayurveda:",
      p2Ayurveda: "Wie entsteht Gesundheit – und wie wird sie erhalten?",
      p3: "AYU bringt diese jahrtausendealte Weisheit in die Neuzeit – personalisiert durch moderne Genetik und angepasst an deine individuelle Lebenssituation.",
      pathogenesisTitle: "Pathogenese",
      pathogenesisDesc: "Wie entsteht Krankheit?",
      ayurvedaTitle: "Ayurveda",
      ayurvedaDesc: "Wie entsteht und bleibt Gesundheit?",
      pillarsHeading: "Die 5 Säulen deines AYU",
      pillar1Title: "Ernährung",
      pillar1Desc: "Personalisierte Empfehlungen basierend auf deinem Phänotyp – nicht auf allgemeinen Trends.",
      pillar2Title: "Bewegung",
      pillar2Desc: "Die richtige Art und Intensität von Bewegung für deinen Körpertyp und Lebensstil.",
      pillar3Title: "Mentale Balance",
      pillar3Desc: "Achtsamkeitsübungen und Routinen, die zu deiner persönlichen Konstitution passen.",
      pillar4Title: "Tagesrhythmus",
      pillar4Desc: "Optimale Zeiten für Essen, Schlafen und Aktivität – abgestimmt auf deine innere Uhr.",
      pillar5Title: "Prävention",
      pillar5Desc: "Frühzeitig erkennen, was dein Körper braucht – bevor Symptome entstehen.",
    },
    phenotyp: {
      badge: "Die Wissenschaft dahinter",
      heading1: "12",
      heading2: "Phänotypen",
      intro: "Jeder Mensch ist einzigartig. Durch unsere Fragebögen bestimmen wir deinen individuellen Phänotyp – einen von 12 Grundtypen, die sich aus drei Faktoren ergeben:",
      genetikTitle: "Genetik",
      genetikDesc: "Deine DNA bestimmt grundlegende Veranlagungen – von Stoffwechsel bis Stressreaktion.",
      kulturTitle: "Kultur",
      kulturDesc: "Deine kulturelle Prägung beeinflusst Ernährungsgewohnheiten, Rhythmen und Werte.",
      umweltTitle: "Umwelt",
      umweltDesc: "Klima, Lebensstil und soziales Umfeld formen deine täglichen Gesundheitsbedürfnisse.",
      statement: '„Warum klassischer Ayurveda dir mehr schaden als helfen kann."',
      statementDesc: "Europa ist nicht Indien. Wer Ayurveda 1:1 aus Kerala nach München kopiert, erhält nicht automatisch dieselbe Wirkung. AYU personalisiert Ayurveda für deine tatsächliche Lebenssituation.",
    },
    kompass: {
      badge: "Dein Begleiter",
      heading: "Der AYU-Kompass",
      p1: "Nach deinem Assessment erhältst du Zugang zum AYU-Kompass – deinem persönlichen Gesundheitsbegleiter. Er führt dich Tag für Tag durch Empfehlungen, die genau auf deinen Phänotyp abgestimmt sind.",
      p2: "Dein AYU ist dein persönlicher KI-Gesundheitsassistent. Stelle ihm jederzeit Fragen zu Ernährung, Routinen oder Wohlbefinden – er kennt deinen Phänotyp und gibt dir Antworten, die wirklich zu dir passen.",
      chatHeader: "Mein Gesundheitstagebuch",
      chatSubheader: "AYU Reflexion aktiv",
      inputPlaceholder: "Was bewegt dich gerade?",
      feature1: "Dein persönlicher AYU Chat-Assistent",
      feature2: "Tägliche personalisierte Empfehlungen",
      feature3: "Dein Gesundheitstagebuch",
      feature4: "Fortschritts-Tracking",
      feature5: "Saisonale Anpassungen",
      feature6: "Wöchentliche Rituale & Routinen",
    },
    tagebuch: {
      badge: "Neu: Gesundheitstagebuch",
      heading1: "Nicht nur schreiben.",
      heading2: "Verstehen.",
      description: "Dein AYU Gesundheitstagebuch ist mehr als ein leeres Blatt. Es ist ein Gespräch mit deinem Körper – begleitet von einem Reflexionspartner, der zuhört, Muster erkennt und die richtigen Fragen stellt.",
      chatHeader: "Mein Gesundheitstagebuch",
      chatSubheader: "AYU Reflexion aktiv",
      inputPlaceholder: "Was bewegt dich gerade?",
      ctaButton: "Tagebuch entdecken",
      feature1Title: "Reflektieren",
      feature1Desc: "Halte fest, was dich bewegt – Gedanken, Gefühle, körperliche Signale. Annam hört zu, ohne zu urteilen.",
      feature2Title: "Verstehen",
      feature2Desc: "AYU spiegelt deine Worte zurück und hilft dir, Muster in deiner Gesundheit zu erkennen, die dir sonst verborgen bleiben.",
      feature3Title: "Dokumentieren",
      feature3Desc: "Jeder Eintrag wird Teil deiner persönlichen Gesundheitsreise. Über die Zeit erkennst du, wie sich dein Wohlbefinden verändert.",
      feature4Title: "Wachsen",
      feature4Desc: "Kein Tagebuch, das verstaubt. Ein lebendiger Dialog, der dich täglich ein Stück näher zu deiner Balance bringt.",
    },
    annam: {
      badge: "Die Gründerin",
      heading1: "Eine Frau. Eine",
      heading2: "Mission",
      annamTitle: "Annam Hanfstein",
      annamRole: "Gründerin & CEO – AYU-rveda",
      quote: '„Meine Hingabe spürst du in jeder Empfehlung, jedem Ritual – und in jedem Moment, in dem du dich gesehen, verstanden und gestärkt fühlst."',
      p1: "Annam Hanfstein wurde Ayurveda förmlich in die Wiege gelegt – als Tochter einer traditionellen indischen Heilerfamilie wurde sie schon früh mit den Prinzipien von Balance, Heilung und Energie großgezogen.",
      p2: "Bis heute hat sie über 180.000 Menschen auf ihrem Weg zu Gesundheit, innerer Ruhe und persönlicher Entwicklung begleitet – durch Ayurveda, Achtsamkeit und gelebte Weisheit.",
      p3: "Mit AYU bringt sie nun ihre jahrzehntelange Erfahrung in ein System, das jedem Menschen einen individuellen Zugang zu dieser uralten Lehre ermöglicht – angepasst an die moderne Welt, in der wir leben.",
      chrisTitle: "Christopher Hanfstein",
      chrisDesc: "Health-Tech-Investor & Gründer von GENOpuzzle.com – der technologische Kopf hinter dem AYU-System.",
    },
    betreuer: {
      badge: "Echte Menschen. Echtes Verständnis.",
      heading: "Dein Betreuer-Team",
      description: "Du buchst keinen anonymen Termin. Du triffst Menschen, die zuhören, verstehen und dich ehrlich beraten.",
      lilliName: "Lilli",
      lilliRole: "Ernährungsberaterin & Mentalcoach",
      lilliDesc: "Zweifache Mama und leidenschaftlich sportbegeistert. Seit 2015 begleitet sie Menschen auf ihrem Weg zu mehr Gesundheit, Energie und nachhaltiger Balance. Ihr Ansatz verbindet wissenschaftlich fundierte Ernährungsstrategien mit mentaler Arbeit für langfristige Verhaltensveränderungen.",
      lilliTag1: "Ernährung",
      lilliTag2: "Mentalcoaching",
      lilliTag3: "Ganzheitlich",
      silkeName: "Silke",
      silkeRole: "Ganzheitliche Ernährungsberaterin & Coach",
      silkeDesc: "Meine Vision ist es, Menschen auf ganzheitlicher Ebene zu unterstützen, damit sie ihr eigenes Körpergefühl zurückerlangen und sich daraus ein gesundes, zufriedenes und glückliches Leben erschaffen.",
      silkeTag1: "Ernährung",
      silkeTag2: "Coaching",
      silkeTag3: "Körperbewusstsein",
      susanName: "Susan",
      susanRole: "Ernährungsberaterin & Gesundheitscoach",
      susanDesc: "Durch ihre eigene Krebserkrankung und Schilddrüsenprobleme hat Susan erfahren, wie wichtig Gesundheit und bewusste Ernährung für unser Leben sind. Heute gibt sie ihr Wissen weiter und zeigt anderen, wie sehr unsere Gesundheit von unserem Lebensstil abhängen kann.",
      susanTag1: "Ernährung",
      susanTag2: "Gesundheitscoaching",
      susanTag3: "Prävention",
    },
    testimonials: {
      badge: "Erfahrungen",
      heading: "Was Menschen über AYU sagen",
      t1: "AYU hat mir eine Klarheit gegeben, von der ich nicht wusste, dass sie mir fehlte. Statt endloser Ratschläge habe ich endlich verstanden, was wirklich für meinen Körper zählt.",
      t2: "Was mich am meisten beeindruckt hat, war, wie praktisch alles war. Kein Druck, keine Extreme – nur klare Prioritäten, mit denen ich tatsächlich leben kann.",
      t3: "Ich habe viele Gesundheitsansätze ausprobiert, aber AYU war der erste, der sich persönlich anfühlte, ohne überwältigend zu sein.",
      t4: "AYU sagt dir nicht, was du tun sollst – es hilft dir, dich selbst zu verstehen. Das allein hat verändert, wie ich an meine Gesundheit herangehe.",
      t5: "Statt Optimierung zu jagen, gab mir AYU Orientierung. Das hat meine Routinen zum ersten Mal nachhaltig gemacht.",
      t6: "Zum ersten Mal fühlte sich Gesundheitsberatung an mein echtes Leben angepasst an, nicht an eine ideale Version davon.",
    },
    targetGroup: {
      badge: "Für wen ist AYU?",
      heading1: "AYU ist für",
      heading2: "dich",
      description: "Egal, wo du im Leben stehst – AYU gibt dir die Klarheit, die du brauchst.",
      group1Title: "Eltern & Familien",
      group1Desc: "Die zwischen Familie und eigener Energie balancieren",
      group2Title: "Berufstätige",
      group2Desc: "Unter konstantem Druck und Leistungsanforderung",
      group3Title: "Unternehmer",
      group3Desc: "Die ihre Performance nachhaltig optimieren wollen",
    },
    faq: {
      badge: "Häufige Fragen",
      heading1: "Alles, was du wissen",
      heading2: "musst",
      q1: "Was ist AYU?",
      a1: "AYU ist ein personalisiertes Gesundheits- und Lifestyle-System. Es verbindet die Prinzipien des Ayurveda mit moderner KI-gestützter Mustererkennung, um dir zu helfen, deinen Körper, Geist und Lebensstil zu verstehen – und dieses Wissen in praktische, tägliche Empfehlungen umzusetzen.",
      q2: "Ist AYU ein medizinischer Dienst?",
      a2: "Nein. AYU ist ausschließlich präventiv und bildend. Es diagnostiziert nicht, behandelt nicht und ersetzt keine ärztliche Beratung. Es hilft dir, Muster, Prioritäten und Gewohnheiten zu verstehen, die dein langfristiges Wohlbefinden unterstützen.",
      q3: "Wie funktioniert die Personalisierung?",
      a3: "Du füllst einen strukturierten Fragebogen aus, der familiäre Hintergründe, mentale Muster und Lebensstilfaktoren abdeckt. AYU analysiert diese Informationen und identifiziert deinen persönlichen Phänotyp – einen von 12 menschlichen Grundtypen, die auf Genetik, Kultur und Umwelt basieren.",
      q4: "Brauche ich Vorkenntnisse über Ayurveda?",
      a4: "Überhaupt nicht. AYU ist für das moderne Leben konzipiert. Keine Sanskrit-Begriffe, keine starren Regeln, kein Glaubenssystem. Alles wird klar erklärt und in alltagstaugliche Handlungen übersetzt.",
      q5: "Was erhalte ich nach dem Assessment?",
      a5: "Du erhältst einen personalisierten AYU-Bericht mit klaren Empfehlungen zu Ernährung, Routinen, Bewegung, mentaler Balance und langfristigen präventiven Prioritäten – zugeschnitten auf dein Leben, nicht auf eine idealisierte Routine.",
      q6: "Für wen ist AYU geeignet?",
      a6: "AYU ist für Menschen, die Klarheit statt Verwirrung wollen – Eltern, Berufstätige, Unternehmer oder alle, die Verantwortung für ihre langfristige Gesundheit übernehmen möchten, ohne Obsession, Trends oder Überforderung.",
      q7: "Was unterscheidet AYU von klassischem Ayurveda?",
      a7: "Klassischer Ayurveda wurde für Menschen in Indien entwickelt. AYU berücksichtigt, dass wir uns in Genetik, Kultur und Umwelt unterscheiden. Ein System, das in Kerala funktioniert, passt nicht automatisch nach München, New York oder Sydney. AYU personalisiert Ayurveda für deine tatsächliche Lebenssituation.",
      q8: "Was kostet AYU?",
      a8: "AYU bietet verschiedene Zugangsmöglichkeiten – vom Basis-Assessment bis zum umfassenden Gesundheitsplan mit DNA-Analyse. Starte mit dem kostenlosen Erstgespräch, um herauszufinden, welcher Weg für dich der richtige ist.",
    },
    zweiWege: {
      badge: "Dein Weg",
      heading1: "Zwei Wege zu",
      heading2: "deinem AYU",
      description: "Wähle den Zugang, der am besten zu dir passt. Im kostenlosen Beratungsgespräch finden wir gemeinsam heraus, welcher Weg der richtige für dich ist.",
      recommended: "Empfohlen",
      path1Title: "AYU Gesundheitsprogramm",
      path1Subtitle: "Dein persönlicher Gesundheitsplan",
      path1Desc: "Basierend auf dem AYU-Phänotyp-System erhältst du deinen individuellen Gesundheitsplan mit KI-Coach, Tagesroutine und Ernährungsempfehlungen.",
      path1F1: "Persönlicher AYU-Phänotyp-Test (12 Typen)",
      path1F2: "KI-gestützter Gesundheitscoach (Text + Sprache)",
      path1F3: "Personalisierte Tagesroutine (Dinacharya)",
      path1F4: "Individueller Ernährungsplan & Rezepte",
      path1F5: "Geführte Audio-Sessions",
      path1F6: "Gesundheitstagebuch mit KI-Analyse",
      path1F7: "Fortschritts-Tracking & Streaks",
      path1F8: "Telegram-Bot für unterwegs",
      path2Title: "AYU + Genetischer Darm-Mikrobiom-Test",
      path2Subtitle: "Die volle Tiefe",
      path2Desc: "Alles aus dem AYU Programm plus genetischer Darm-Mikrobiom-Analyse für noch präzisere, wissenschaftlich fundierte Empfehlungen.",
      path2F1: "Alles aus dem AYU Gesundheitsprogramm",
      path2F2: "Genetischer Darm-Mikrobiom-Test (Laboranalyse)",
      path2F3: "Detaillierte Mikrobiom-Auswertung im Dashboard",
      path2F4: "Noch präzisere Ernährungs- & Gesundheitsempfehlungen",
      path2F5: "Persönliche Beratung zur Mikrobiom-Analyse",
      ctaButton: "Beratungsgespräch buchen",
      footnote: "Im kostenlosen Beratungsgespräch besprechen wir gemeinsam, welches Programm am besten zu dir passt.",
    },
    video: {
      badge: "Einführung",
      heading: "Annam erklärt AYU",
      description: "Erfahre in diesem Video, wie AYU funktioniert und warum personalisierter Ayurveda der Schlüssel zu deiner Gesundheit ist.",
      previewTitle: "AYU – Dein persönlicher Gesundheitsplan",
      previewSubtitle: "Annam stellt AYU vor",
      videoPreview: "Video Vorschau",
      playAriaLabel: "Video abspielen",
    },
    cta: {
      heading1: "Bereit, dich selbst zu",
      heading2: "verstehen",
      description: "Dein persönliches Assessment dauert etwa 15 Minuten. Keine Verpflichtung. Keine medizinische Diagnose. Nur Klarheit.",
      button: "Jetzt Assessment starten",
      trust: "Über 180.000 Menschen vertrauen bereits auf Annams Expertise",
    },
    buch: {
      badge: "Das Buch",
      heading: "Der AYU",
      subtitle: "Tradition trifft Genetik",
      description: "Warum traditionelles Ayurveda in Europa nicht funktioniert – und wie der AYU-Ansatz das ändert. Von Annam & Christopher Hanfstein. Erhältlich als E-Book und Print-Ausgabe, in Deutsch und Englisch.",
      stars: "Leser-Bewertungen",
      ebookFrom: "E-Book ab",
      print: "Print",
      cta: "Mehr erfahren & bestellen",
    },
    footer: {
      description: "AYU verbindet 5.000 Jahre Ayurveda-Weisheit mit moderner Wissenschaft für deinen persönlichen Gesundheitsplan.",
      navigation: "Navigation",
      mehr: "Mehr entdecken",
      assessment: "AYU Assessment",
      ayuErlebenDemo: "AYU erleben (Demo)",
      ayuErleben: "AYU erleben",
      video: "Video",
      terminBuchen: "Termin buchen",
      kontakt: "Kontakt",
      rechtliches: "Rechtliches",
      datenschutz: "Datenschutz",
      impressum: "Impressum",
      agb: "AGB",
      copyright: "AYU Healthtech LIMITED. Alle Rechte vorbehalten.",
      disclaimer: "AYU ist ein präventives Lifestyle-System und ersetzt keine ärztliche Beratung.",
    },
  },

  ayuErleben: {
    hero: {
      badge: "AYU Erleben",
      heading1: "Dein Tag mit",
      description: "Kein einmaliger Test. Kein statischer Report. Sondern ein lebendiges System, das dich jeden Tag begleitet — basierend auf deinem einzigartigen Phänotyp und jahrtausendealter ayurvedischer Weisheit.",
    },
    timeline: {
      badge: "Dein Tagesablauf",
      heading1: "Ein Tag in deinem",
      heading2: "Ayurvedischen Gesundheitssystem",
      description: "Von morgens bis abends — dein AYU Health Coach begleitet dich durch den Tag mit Empfehlungen, die auf deinem Phänotyp basieren.",
      phoneTitle: "AYU Health Coach",
      phoneSub: "Tagesbegleitung aktiv",
      inputPlaceholder: "Was bewegt dich gerade?",
      labelCoach: "AYU HEALTH COACH",
      labelRec: "EMPFEHLUNG",
      labelTip: "TIPP",
      labelBreath: "ATEMÜBUNG",
      labelBalance: "TAGESBILANZ",
      slot1Title: "Morgen-Check-in",
      slot1DateLabel: "07:00 — Morgen-Check-in",
      slot1Bot1: "Guten Morgen! Dein Schlaf-Score zeigt 7.4h mit guter Tiefschlafphase. Dein Phänotyp profitiert heute von warmem Ingwerwasser und einer leichten Yoga-Einheit.",
      slot1Bot2: "Dein Agni — dein Verdauungsfeuer — ist morgens am stärksten. Perfekter Zeitpunkt für ein nährstoffreiches Frühstück mit Haferflocken, Zimt und warmem Ghee.",
      slot1User1: "Soll ich heute Morgen lieber Yoga oder Spaziergang machen?",
      slot1Bot3: "Bei deinem Phänotyp und dem heutigen Wetter: 15 Minuten Sonnengruß, gefolgt von 10 Minuten Pranayama. Das aktiviert deinen Stoffwechsel sanft und nachhaltig.",
      slot2Title: "Mittags-Empfehlung",
      slot2DateLabel: "12:30 — Mittags-Empfehlung",
      slot2Bot1: "Mittagszeit! Dein Phänotyp zeigt eine Tendenz zu Nachmittagsmüdigkeit. Empfehlung: Eine warme Mahlzeit mit Kurkuma und Kreuzkümmel stärkt dein Agni.",
      slot2User1: "Ich habe nur 20 Minuten Pause. Was geht schnell?",
      slot2Bot2: "Kitchari — Reis mit Mungbohnen und Gewürzen. Du kannst es morgens vorbereiten und aufwärmen. Vermeide kalte Getränke — sie verlangsamen deine Verdauung.",
      slot2Bot3: "15 Minuten Spaziergang nach dem Essen aktiviert deinen Stoffwechsel. Selbst 5 Minuten helfen bereits.",
      slot3Title: "Nachmittags-Boost",
      slot3DateLabel: "16:00 — Nachmittags-Boost",
      slot3Bot1: "Dein Energielevel sinkt typischerweise um diese Zeit. Statt Kaffee empfehle ich dir Tulsi-Tee — er passt perfekt zu deinem Phänotyp.",
      slot3User1: "Warum kein Kaffee? Ich brauche den Kick...",
      slot3Bot2: "Kaffee erhöht dein Cortisol kurzfristig, aber bei deinem Phänotyp führt das abends zu Einschlafproblemen. Tulsi reguliert dein Cortisol sanft von innen.",
      slot3Bot3: "Dazu 5 Minuten Pranayama: 4 Sekunden einatmen, 7 halten, 8 ausatmen. Das gibt dir natürliche Energie ohne Crash.",
      slot4Title: "Abend-Routine",
      slot4DateLabel: "21:00 — Abend-Routine",
      slot4Bot1: "Zeit für deine Abend-Routine. Dein Phänotyp reagiert sensibel auf blaues Licht — Bildschirme ab jetzt meiden.",
      slot4User1: "Was kann ich stattdessen machen?",
      slot4Bot2: "Empfehlung: Warme Goldene Milch mit Ashwagandha und Muskatnuss. Dazu 10 Minuten leichte Dehnung oder Journaling.",
      slot4Bot3: "Dein Tagebuch-Eintrag von heute zeigt positive Entwicklung: Energie +12% diese Woche, Schlafqualität verbessert. Weiter so! Gute Nacht.",
    },
    diary: {
      badge: "Gesundheitstagebuch",
      heading1: "Nicht nur schreiben.",
      heading2: "Verstehen.",
      description: "Dein AYU Gesundheitstagebuch ist mehr als ein leeres Blatt. Es ist ein Gespräch mit deinem Körper — begleitet von einem Reflexionspartner, der zuhört, Muster erkennt und die richtigen Fragen stellt.",
      phoneTitle: "Mein Gesundheitstagebuch",
      phoneSub: "AYU Reflexion aktiv",
      ctaButton: "Tagebuch entdecken",
      labelReflect: "AYU REFLEXION",
      labelPattern: "MUSTER ERKANNT",
      labelWeekly: "WOCHENBERICHT",
      labelMonthly: "MONATSBERICHT",
      f1Title: "Reflektieren",
      f1Desc: "Halte fest, was dich bewegt — Gedanken, Gefühle, körperliche Signale. Annam hört zu, ohne zu urteilen.",
      f1DateLabel: "Tagebuch — Reflektieren",
      f1User1: "Heute fühle ich mich schwer und antriebslos. Liegt das an meiner Ernährung?",
      f1Bot1: "Das klingt, als ob dein Körper dir ein Signal sendet. Bei deinem Phänotyp kann sich Schwere besonders in den Übergangszeiten zeigen.",
      f1Bot2: "Dein Agni (Verdauungsfeuer) braucht jetzt Unterstützung — warme, leichte Speisen mit Ingwer und Kreuzkümmel können helfen.",
      f2Title: "Verstehen",
      f2Desc: "AYU spiegelt deine Worte zurück und hilft dir, Muster in deiner Gesundheit zu erkennen, die dir sonst verborgen bleiben.",
      f2DateLabel: "Tagebuch — Verstehen",
      f2User1: "Mir ist aufgefallen, dass ich immer nach dem Mittagessen müde werde.",
      f2Bot1: "Deine Einträge der letzten 2 Wochen zeigen ein klares Muster: An Tagen mit kaltem Mittagessen sinkt dein Energielevel um 40%.",
      f2Bot2: "Dein Phänotyp braucht warme Mahlzeiten zur Mittagszeit. Das stärkt dein Agni und verhindert das Nachmittagstief.",
      f3Title: "Dokumentieren",
      f3Desc: "Jeder Eintrag wird Teil deiner persönlichen Gesundheitsreise. Über die Zeit erkennst du, wie sich dein Wohlbefinden verändert.",
      f3DateLabel: "Tagebuch — Dokumentieren",
      f3Bot1: "Dein Wochenbericht ist da! Hier sind deine Highlights:",
      f3Bot2: "• Ernährung: 6/7 Tage warm gegessen ✓\n• Bewegung: 5/7 Tage aktiv ✓\n• Schlaf: Ø 7,2 Stunden\n• Stimmung: Aufwärtstrend ↑",
      f3User1: "Das motiviert mich weiterzumachen!",
      f4Title: "Wachsen",
      f4Desc: "Kein Tagebuch, das verstaubt. Ein lebendiger Dialog, der dich täglich ein Stück näher zu deiner Balance bringt.",
      f4DateLabel: "Tagebuch — Wachsen",
      f4Bot1: "Dein Monatsbericht für Februar ist da! Beeindruckende Entwicklung:",
      f4Bot2: "• Energie-Level: +35% gegenüber Januar\n• Verdauung: Deutlich verbessert\n• Schlaf: Von 5,8 auf 7,4\n• Stresslevel: -20%",
      f4Bot3: "Dein Körper reagiert positiv auf die ayurvedischen Anpassungen. Im März fokussieren wir uns auf deine Abendroutine — das hat das größte Potenzial.",
    },
    wearables: {
      badge: "Verbinde alles",
      heading1: "Deine Daten.",
      heading2: "Ein System.",
      description: "AYU verbindet deinen Phänotyp mit tagesaktuellen Daten aus Wearables, Bluttests und deinem Tagebuch zu einem ganzheitlichen Gesundheitsbild.",
      ouraName: "Oura Ring",
      ouraMetrics: "Schlaf, HRV, Temperatur",
      whoopName: "Whoop",
      whoopMetrics: "Strain, Recovery, Schlaf",
      garminName: "Garmin",
      garminMetrics: "Aktivität, Stress, Schlaf",
      fitbitName: "Fitbit",
      fitbitMetrics: "Schritte, HRV, SpO2",
      withingsName: "Withings",
      withingsMetrics: "Gewicht, Blutdruck, EKG",
      polarName: "Polar",
      polarMetrics: "Training, HRV, Schlaf",
      bloodName: "Bluttests",
      bloodMetrics: "CRP, Vitamin D, Eisen",
    },
    cta: {
      heading1: "Bereit, deinen Phänotyp",
      heading2: "zu entdecken?",
      description: "Was du gerade gesehen hast, ist nur ein kleiner Einblick. Mit deinem persönlichen AYU-Assessment erhältst du Empfehlungen, die exakt auf deinen Phänotyp zugeschnitten sind.",
      button: "Deine AYU Journey starten",
      time: "15 Minuten",
      free: "Kostenlos starten",
      noObligation: "Unverbindlich",
      backLink: "← Zurück zur Übersicht",
    },
  },

  erleben: {
    hero: {
      badge: "So klingt eine AYU Session",
      heading1: "Erlebe AYU.",
      heading2: "Ganz ohne Druck.",
      description: "Wähle ein Thema, das dich anspricht. Beobachte, wie AYU zuhört, analysiert und die richtigen Empfehlungen gibt.",
    },
    topics: {
      t1Title: "Longevity",
      t1Subtitle: "Gesundes Altern & Neuroprotektion",
      t1M1: "Neue Gesundheits-Session",
      t1M2: "Hallo. Schön, dass du dir diesen Moment nimmst. Wenn du an dein Altern denkst — was beschäftigt dich am meisten? Sei ganz ehrlich.",
      t1M3: "Ich merke, dass ich vergesslicher werde. Manchmal finde ich Wörter nicht mehr. Und ich bin erst 42. Das macht mir Angst.",
      t1M4: "Das ist ein wichtiger Hinweis. Vergesslichkeit in deinem Alter ist selten ein Zeichen von Abbau — sie zeigt oft, dass dein Nervensystem überlastet ist. Dein Gehirn priorisiert Stressbewältigung vor Erinnerung.",
      t1M5: "Also ist es Stress? Aber ich schlafe doch genug...",
      t1M6Label: "MUSTER ERKANNT",
      t1M6: 'Schlafquantität ist nicht Schlafqualität. Dein Phänotyp zeigt eine Tendenz zu oberflächlichem Schlaf mit hoher Cortisol-Aktivität in den frühen Morgenstunden. Das bedeutet: Dein Gehirn regeneriert sich nachts nicht vollständig. Die ayurvedischen Rasayanas — Verjüngungsmittel — setzen genau hier an.',
      t1M7: "Session-Zusammenfassung",
      t1M8Label: "DEIN GESUNDHEITS-MOMENT",
      t1M8: "Deine Vergesslichkeit ist kein Zeichen von Alterung — sie ist ein Signal deines Nervensystems. Mit gezielter Neuroprotektion durch adaptierte Rasayana-Protokolle und Schlafoptimierung kannst du deine kognitive Klarheit nicht nur erhalten, sondern verbessern.",
      t2Title: "Darm-Hirn-Achse",
      t2Subtitle: "Mikrobiom & mentale Gesundheit",
      t2M1: "Neue Gesundheits-Session",
      t2M2: "Willkommen. Lass uns über etwas sprechen, das die meisten unterschätzen: die Verbindung zwischen deinem Bauch und deinem Kopf. Wie geht es deiner Verdauung — ehrlich?",
      t2M3: "Naja, ich hab ständig Blähungen und fühle mich nach dem Essen müde. Und irgendwie bin ich auch oft grundlos gereizt.",
      t2M4: "Das ist kein Zufall. Ayurveda sagt seit 5.000 Jahren: 'Alle Krankheit beginnt im Darm.' Die moderne Wissenschaft bestätigt das jetzt. Dein Darm produziert 90% deines Serotonins — wenn er gestört ist, leidet deine Stimmung direkt.",
      t2M5: "Heißt das, meine Gereiztheit kommt aus dem Bauch?",
      t2M6Label: "MUSTER ERKANNT",
      t2M6: "Genau. Dein Phänotyp zeigt eine Verdauungssensibilität, die sich direkt auf deine emotionale Balance auswirkt. Die Darm-Hirn-Achse ist bei dir besonders aktiv. Das bedeutet: Wenn wir dein Agni — dein Verdauungsfeuer — stärken, verbessern sich nicht nur Blähungen, sondern auch deine mentale Klarheit und Gelassenheit.",
      t2M7: "Session-Zusammenfassung",
      t2M8Label: "DEIN GESUNDHEITS-MOMENT",
      t2M8: "Deine Gereiztheit ist keine Charakterschwäche — sie ist ein Signal deines Mikrobioms. Durch gezielte Stärkung deines Verdauungsfeuers mit phänotyp-spezifischen Kräutern und Ernährungsanpassungen kannst du gleichzeitig deine Verdauung und deine emotionale Balance transformieren.",
      t3Title: "Adaptogene",
      t3Subtitle: "Natürliche Kraft gegen Stress",
      t3M1: "Neue Gesundheits-Session",
      t3M2: "Hallo. Lass uns über etwas sprechen, das gerade die Welt bewegt: Adaptogene. Pflanzen wie Ashwagandha haben 670 Millionen Views auf TikTok. Aber was bedeuten sie für dich persönlich?",
      t3M3: "Ich nehme seit Monaten Ashwagandha-Kapseln aus dem Internet. Ehrlich gesagt merke ich nicht viel. Vielleicht mache ich was falsch?",
      t3M4: "Du machst nichts 'falsch' — aber du nimmst ein Mittel, das nicht zu deinem Phänotyp passt. Ashwagandha ist nicht für jeden gleich wirksam. Für manche Konstitutionen kann es sogar kontraproduktiv sein.",
      t3M5: "Wirklich? Aber alle sagen, es hilft gegen Stress...",
      t3M6Label: "MUSTER ERKANNT",
      t3M6: "Das ist das Problem mit One-Size-Fits-All-Trends. Dein Phänotyp zeigt eine Stressreaktion, die eher auf Brahmi und Tulsi anspricht als auf Ashwagandha. Der Unterschied: Ashwagandha beruhigt das Nervensystem von außen, während Brahmi deine spezifische Art der Reizüberflutung von innen reguliert. Personalisierung ist der Schlüssel.",
      t3M7: "Session-Zusammenfassung",
      t3M8Label: "DEIN GESUNDHEITS-MOMENT",
      t3M8: "Nicht jedes Adaptogen passt zu jedem Menschen. Statt blindem Trend-Following brauchst du die Pflanze, die zu deinem Phänotyp passt. AYU identifiziert genau das — basierend auf deiner Genetik, Kultur und Umwelt, nicht auf TikTok-Algorithmen.",
    },
    chat: {
      healthLabel: "AYU Gesundheit",
      sessionActive: "Session aktiv",
      sessionComplete: "Session abgeschlossen",
      skipButton: "Überspringen",
      inputPlaceholder: "Dies ist eine Demo-Session...",
      completionText: "Wähle oben ein anderes Thema, um eine weitere Session zu erleben.",
    },
    method: {
      badge: "Was du gerade gesehen hast",
      heading1: "Die AYU",
      heading2: "3-Schritt-Methode",
      step1Title: "Ganzheitliche Analyse",
      step1Desc: "AYU erfasst dein Gesamtbild — Ernährung, Schlaf, Stress, Verdauung — und erkennt Zusammenhänge, die dir verborgen bleiben.",
      step2Title: "Muster-Erkennung",
      step2Desc: "Deine Symptome werden nicht isoliert betrachtet. AYU verbindet sie mit deinem Phänotyp und zeigt dir die wahren Ursachen.",
      step3Title: "Personalisierte Empfehlung",
      step3Desc: "Keine generischen Tipps — sondern Empfehlungen, die exakt zu deiner Konstitution, Kultur und Lebenssituation passen.",
    },
    stats: {
      badge: "Du bist nicht allein",
      heading: "Über 2,5 Milliarden Menschen weltweit leiden an chronischen Gesundheitsproblemen, die vermeidbar wären.",
      stat1Value: "1,7 Mrd.",
      stat1Label: "Chronische Verdauungsprobleme",
      stat2Value: "670 Mio.",
      stat2Label: "Ashwagandha-Views auf TikTok",
      stat3Value: "1 von 3",
      stat3Label: "Menschen mit Schlafstörungen",
      source: "Quellen: WHO Global Health Report 2025, TikTok Analytics 2026",
    },
    cta: {
      heading1: "Bereit, es selbst",
      heading2: "zu erleben?",
      description: "Was du gerade gesehen hast, ist nur ein kleiner Einblick. Mit deinem persönlichen AYU-Assessment erhältst du Empfehlungen, die exakt auf deinen Phänotyp zugeschnitten sind.",
      button: "Deine AYU Journey starten",
      time: "15 Minuten",
      free: "Kostenlos starten",
      noObligation: "Unverbindlich",
      email: "Lieber per E-Mail?",
    },
  },

  errors: {
    allgemein: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
    netzwerk: "Netzwerkfehler. Bitte überprüfe deine Verbindung.",
    laden: "Daten konnten nicht geladen werden.",
    speichern: "Daten konnten nicht gespeichert werden.",
    nichtGefunden: "Seite nicht gefunden.",
    zugriffVerweigert: "Zugriff verweigert.",
  },

  video: {
    navCta: "Termin buchen",
    heroBadge: "Exklusives Video",
    heroTitle1: "Entdecke, wie AYU",
    heroTitle2: "dich begleitet",
    heroDesc: "Nimm dir einen Moment. Dieses Video zeigt dir, was AYU für dich tun kann — ehrlich, klar und ohne Versprechen.",
    iframeTitle: "AYU – Dein persönlicher Gesundheitsplan",
    badgeFree: "Kostenlos",
    badgeNoDiagnosis: "Keine Diagnose",
    badgeNoObligation: "Keine Verpflichtung",
    demoBadge: "Selbst erleben",
    demoTitle1: "Teste AYU jetzt —",
    demoTitle2: "7 Minuten, kostenlos",
    demoDesc: "Erlebe die AYU-App live mit dem Demo-Account von Max Muster. Schau dir das Dashboard, den KI-Coach und die Tagesroutine an — ganz ohne Registrierung.",
    demoLiveDuration: "7 Minuten Live-Demo",
    demoNoRegistration: "Keine Registrierung nötig",
    demoAllFeatures: "Alle Features entdecken",
    demoButton: "Demo starten",
    ctaBadge: "Dein nächster Schritt",
    ctaTitle: "Bereit für ein persönliches Gespräch?",
    ctaDesc: "Du hast gesehen, was AYU kann. Jetzt ist der Moment, den nächsten Schritt zu gehen. Buche ein kostenloses Beratungsgespräch — unverbindlich, persönlich und ganz auf dich zugeschnitten.",
    ctaBadge1: "100% kostenlos & unverbindlich",
    ctaBadge2: "Ca. 20 Minuten",
    ctaBadge3: "Persönliche Beratung",
    ctaButton: "Jetzt Termin buchen",
    quoteText: "Ich freue mich darauf, dich persönlich kennenzulernen und gemeinsam herauszufinden, wie AYU dich auf deinem Weg begleiten kann.",
    quoteAuthor: "Annam Hanfstein",
    quoteRole: "Gründerin von AYU · Ayurveda-Coach",
    footerImpressum: "Impressum",
    footerDatenschutz: "Datenschutz",
    footerKontakt: "Kontakt",
    footerDisclaimer: "AYU ist ein präventives Lifestyle-System und ersetzt keine ärztliche Beratung.",
  },

  demoRegistration: {
    navBack: "Zurück zur Startseite",
    heroBadge: "7-Minuten Demo",
    heroTitle1: "Erlebe AYU in",
    heroTitle2: "7 Minuten",
    heroDesc: "Entdecke deinen persönlichen Ayurveda-Gesundheitsplan. Registriere dich kurz und starte sofort die interaktive Demo — kostenlos und unverbindlich.",
    trustBadge1: "Interaktive Demo mit KI-Coach",
    trustBadge2: "Deine Daten sind DSGVO-konform geschützt",
    trustBadge3: "Kostenlos und unverbindlich",
    successTitle: "Perfekt, los geht's!",
    successDesc: "Deine Registrierung war erfolgreich. Die Demo wird jetzt geladen...",
    successLoading: "Demo wird gestartet...",
    formTitle: "Demo starten",
    formSubtitle: "Registriere dich kurz, um die AYU-Demo zu erleben",
    labelFirstName: "Vorname",
    placeholderFirstName: "Max",
    labelLastName: "Nachname",
    placeholderLastName: "Mustermann",
    labelEmail: "E-Mail-Adresse",
    placeholderEmail: "max@beispiel.de",
    labelPhone: "Telefonnummer",
    placeholderPhone: "+49 170 1234567",
    submitLoading: "Wird geladen...",
    submitButton: "Demo starten",
    privacyText: "Mit der Registrierung stimmst du unserer",
    privacyLink: "Datenschutzerklärung",
    privacyAfter: "zu. Wir geben deine Daten niemals an Dritte weiter.",
    footerImpressum: "Impressum",
    footerDatenschutz: "Datenschutz",
    errorFirstName: "Bitte gib deinen Vornamen ein",
    errorLastName: "Bitte gib deinen Nachnamen ein",
    errorPhoneRequired: "Bitte gib deine Telefonnummer ein",
    errorPhoneInvalid: "Bitte gib eine gültige Telefonnummer ein (z.B. +49 170 1234567)",
    errorEmailRequired: "Bitte gib deine E-Mail-Adresse ein",
    errorEmailInvalid: "Bitte gib eine gültige E-Mail-Adresse ein",
    errorGeneral: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
  },

  registrierung: {
    navBack: "Zurück",
    stepIndicator: "Schritt 1 von 3",
    heroTitle1: "Starte deine",
    heroTitle2: "persönliche",
    heroTitle3: "AYU Journey",
    heroDesc: "Registriere dich kostenlos und erhalte sofort Zugang zu deinem personalisierten Gesundheitsvideo. Keine Verpflichtung, kein Abo.",
    trustBadge1: "Deine Daten sind DSGVO-konform geschützt",
    trustBadge2: "100% kostenlos und unverbindlich",
    trustBadge3: "Sofortiger Zugang nach Registrierung",
    alreadyLoggedInTitle: "Du bist bereits angemeldet",
    alreadyLoggedInDesc: "Willkommen zurück",
    alreadyLoggedInDescSuffix: "! Du hast bereits ein AYU-Konto. Wir leiten dich zu deiner App weiter...",
    redirectingToApp: "Weiterleitung zur App...",
    goToApp: "Jetzt zur App",
    alreadyRegisteredTitle: "Wir kennen dich bereits!",
    alreadyRegisteredDesc: "Du hast dich mit dieser E-Mail-Adresse bereits registriert. Du wirst gleich zu deinem Video weitergeleitet...",
    successTitle: "Willkommen bei AYU!",
    successDesc: "Deine Registrierung war erfolgreich. Du wirst gleich zu deinem Video weitergeleitet...",
    redirecting: "Weiterleitung...",
    formTitle: "Kostenlos registrieren",
    formSubtitle: "Erhalte sofort Zugang zu deinem personalisierten Video",
    labelFirstName: "Vorname",
    placeholderFirstName: "Max",
    labelLastName: "Familienname",
    placeholderLastName: "Mustermann",
    labelPhone: "Telefonnummer",
    placeholderPhone: "+49 170 1234567",
    labelEmail: "E-Mail-Adresse",
    placeholderEmail: "max@beispiel.de",
    submitLoading: "Wird gesendet...",
    submitButton: "Kostenlos registrieren",
    privacyText: "Mit der Registrierung stimmst du unserer",
    privacyLink: "Datenschutzerklärung",
    privacyAfter: "zu. Wir geben deine Daten niemals an Dritte weiter.",
    footerImpressum: "Impressum",
    footerDatenschutz: "Datenschutz",
    errorFirstNameRequired: "Bitte gib deinen Vornamen ein.",
    errorFirstNameMinLength: "Der Vorname muss mindestens 2 Zeichen lang sein.",
    errorFirstNameInvalid: "Bitte gib einen gültigen Vornamen ein (nur Buchstaben, Leerzeichen, Bindestriche).",
    errorLastNameRequired: "Bitte gib deinen Familiennamen ein.",
    errorLastNameMinLength: "Der Familienname muss mindestens 2 Zeichen lang sein.",
    errorLastNameInvalid: "Bitte gib einen gültigen Familiennamen ein (nur Buchstaben, Leerzeichen, Bindestriche).",
    errorPhoneRequired: "Bitte gib deine Telefonnummer ein.",
    errorPhoneInvalid: "Bitte gib eine gültige Telefonnummer ein (z.B. +49 170 1234567).",
    errorEmailRequired: "Bitte gib deine E-Mail-Adresse ein.",
    errorEmailInvalid: "Bitte gib eine gültige E-Mail-Adresse ein (z.B. max@beispiel.de).",
    errorGeneral: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
  },

  funnel: {
    navCta: "Jetzt entdecken",
    heroBadge: "Dein Körper. Deine Balance.",
    heroTitle1: "Dein Körper weiß,",
    heroTitle2: "was dir fehlt",
    heroDesc: "AYU ist dein persönlicher Gesundheitsbegleiter. Kein Arzt. Kein Trend. Ein System — das 5.000 Jahre Ayurveda-Weisheit mit deiner einzigartigen Genetik verbindet.",
    heroCtaPrimary: "Kostenlos entdecken",
    heroCtaSecondary: "Mehr erfahren",
    heroBadgeDsgvo: "DSGVO-konform",
    heroBadgeNatural: "100% natürlich",
    heroBadgePersonalized: "Personalisiert",
    painBadge: "Kennst du das?",
    painTitle1: "Wenn sich alles",
    painTitle2: "zu viel",
    painTitle3: "anfühlt",
    pain1Title: "Verdauungsprobleme",
    pain1Text: "Blähungen, Müdigkeit nach dem Essen, ein Gefühl der Schwere. Dein Körper sagt dir etwas — aber du weißt nicht, was.",
    pain2Title: "Energielosigkeit",
    pain2Text: "Du schläfst genug, isst gesund — und bist trotzdem erschöpft. Als würde dein Körper gegen dich arbeiten.",
    pain3Title: "Hautprobleme & Unruhe",
    pain3Text: "Unreine Haut, innere Unruhe, Schlafstörungen. Symptome, die kein Arzt richtig einordnen kann.",
    pain4Title: "Informationsflut",
    pain4Text: "Jeder Podcast, jedes Buch sagt etwas anderes. Du hast alles probiert — und nichts hat wirklich gepasst.",
    painOutro: "Das alles ist normal. Und es gibt einen Weg, damit umzugehen — ohne Druck, ohne Diagnose, ohne Bewertung.",
    feelBadge: "So fühlt sich AYU an",
    feelTitle1: "Ein System, das",
    feelTitle2: "wirklich zu dir passt",
    feelDesc: "Stell dir vor, du hast endlich Klarheit darüber, was dein Körper wirklich braucht. Nicht basierend auf Trends, sondern auf deiner einzigartigen Konstitution. Genau das ist AYU.",
    feel1Title: "Kein Urteil",
    feel1Text: "AYU bewertet nicht. Es analysiert deine einzigartige Konstitution — ehrlich und respektvoll.",
    feel2Title: "Muster erkennen",
    feel2Text: "Mit der Zeit zeigt dir AYU wiederkehrende Gesundheitsthemen, die du allein nicht siehst.",
    feel3Title: "Dein Tempo",
    feel3Text: "Morgens beim Frühstück oder abends vor dem Schlafen — AYU passt sich deinem Rhythmus an.",
    whatBadge: "Was ist AYU?",
    whatTitle1: "Ein Spiegel —",
    whatTitle2: "kein Reparaturdienst",
    whatDesc: "AYU ist ein personalisiertes Gesundheitssystem. Es verbindet 5.000 Jahre Ayurveda-Weisheit mit moderner Wissenschaft, um dir zu helfen, deinen Körper zu verstehen — und dieses Wissen in praktische, tägliche Empfehlungen umzusetzen.",
    step1Num: "01",
    step1Title: "Du beantwortest",
    step1Text: "Per Fragebogen teilst du deine Geschichte — Herkunft, Lebensstil, Ernährung, Befinden.",
    step2Num: "02",
    step2Title: "AYU analysiert",
    step2Text: "Dein Phänotyp wird bestimmt — einer von 12 Grundtypen, basierend auf Genetik, Kultur und Umwelt.",
    step3Num: "03",
    step3Title: "Du lebst gesünder",
    step3Text: "Du erhältst einen personalisierten Plan: Ernährung, Routinen, Bewegung — alles auf dich zugeschnitten.",
    dnaBadge: "Die Körper-Verbindung",
    dnaTitle1: "Dein Darm weiß,",
    dnaTitle2: "was dir fehlt",
    dnaDesc: "Ganzheitliche Gesundheit beginnt nicht nur im Kopf. Der optionale Mikrobiom DNA-Test analysiert über 1.900 Mikrobiom-Positionen und zeigt dir präzise, welche der 47 essenziellen Vitalstoffe dir fehlen — wissenschaftlich fundiert und individuell.",
    dnaFeature1: "1.900+ Mikrobiom-Positionen",
    dnaFeature2: "47 Vitalstoffe analysiert",
    dnaFeature3: "Wissenschaftlich fundiert",
    dnaFeature4: "Individuell auf dich abgestimmt",
    dnaDisclaimer: "Der DNA-Test ist eine optionale Erweiterung. AYU funktioniert auch ohne ihn — aber mit ihm verstehst du dich auf einer ganz neuen Ebene.",
    dnaStatLabel: "Mikrobiom-Positionen",
    dnaBenefit1: "Zeigt dir genau, was deinem Körper fehlt",
    dnaBenefit2: "Keine Schätzungen — wissenschaftlich fundiert",
    dnaBenefit3: "Verbindet Ayurveda mit Körperanalyse",
    dnaBenefit4: "Entwickelt von GENOpuzzle.com",
    pathsBadge: "Dein Weg",
    pathsTitle: "Zwei Wege zu deiner Balance",
    pathsDesc: "Wähle den Weg, der sich für dich richtig anfühlt. Beide führen zu mehr Klarheit.",
    path1Title: "AYU Reflexion",
    path1Sub: "Dein Gesundheitsbegleiter",
    path1Desc: "Dein täglicher Begleiter für ganzheitliche Gesundheit. Beantworte den Fragebogen und erhalte deinen personalisierten Gesundheitsplan.",
    path1Feature1: "Phänotyp-Bestimmung in Echtzeit",
    path1Feature2: "Personalisierter Ernährungsplan",
    path1Feature3: "Tagesrhythmus-Empfehlungen",
    path1Feature4: "24/7 verfügbar auf deinem Handy",
    path1Feature5: "Gesundheitstagebuch",
    path1Cta: "Mehr erfahren",
    path2Badge: "Ganzheitlich",
    path2Title: "AYU + DNA-Test",
    path2Sub: "Die ganzheitliche Verbindung",
    path2Desc: "Ayurveda-Weisheit trifft auf wissenschaftliche Körperanalyse. Verstehe nicht nur, was du brauchst — sondern auch, was dein Körper dir sagt.",
    path2Feature1: "Alles aus AYU Reflexion",
    path2Feature2: "Mikrobiom DNA-Analyse",
    path2Feature3: "1.900+ Mikrobiom-Positionen",
    path2Feature4: "47 Vitalstoffe individuell bemessen",
    path2Feature5: "Persönliche Begleitung durch Annam",
    path2Cta: "Mehr erfahren",
    trustBadge: "Fundament",
    trustTitle: "Gebaut auf Respekt",
    trustDesc: "AYU basiert auf ethischen Grundlagen, die einen sicheren Raum garantieren — frei von Bewertung und Beeinflussung.",
    trust1Title: "Ayurveda-basiert",
    trust1Sub: "5.000 Jahre Weisheit",
    trust2Title: "Ganzheitlich",
    trust2Sub: "Körper & Geist",
    trust3Title: "Verschlüsselt",
    trust3Sub: "Ende-zu-Ende",
    trust4Title: "100% anonym",
    trust4Sub: "Keine Weitergabe",
    trust5Title: "Immer dabei",
    trust5Sub: "Auf deinem Handy",
    testimonialsBadge: "Stimmen",
    testimonialsTitle: "Was andere erlebt haben",
    founderBadge: "Die Geschichte dahinter",
    founderTitle1: "Warum ich AYU",
    founderTitle2: "erschaffen habe",
    founderTag1: "HealthTech Pionierin",
    founderTag2: "AYU-rveda.com",
    founderTag3: "Ayurveda Coach",
    founderText1: "Ayurveda wurde mir förmlich in die Wiege gelegt — als Tochter einer traditionellen indischen Heilerfamilie wurde ich schon früh mit den Prinzipien von Balance, Heilung und Energie großgezogen.",
    founderText2: "Über 180.000 Menschen habe ich auf ihrem Weg zu Gesundheit und innerer Ruhe begleitet. Dabei habe ich immer wieder dasselbe Muster gesehen: Menschen, die alles richtig machen wollten — aber die falschen Empfehlungen bekamen, weil sie nicht zu ihrem Typ passten.",
    founderText3: "AYU ist meine Antwort darauf. Kein weiteres Gesundheitsbuch. Kein allgemeiner Ratschlag. Sondern ein System, das dich als einzigartigen Menschen versteht — und dir genau das gibt, was du brauchst.",
    founderQuote: "Meine Hingabe spürst du in jeder Empfehlung, jedem Ritual — und in jedem Moment, in dem du dich gesehen, verstanden und gestärkt fühlst.",
    founderName: "Annam Hanfstein",
    founderRole: "Gründerin & CEO — AYU-rveda",
    chatBadge: "So sieht AYU aus",
    chatTitle1: "Dein persönlicher",
    chatTitle2: "Gesundheitsbegleiter",
    chatDesc: "AYU kennt deinen Phänotyp und gibt dir Antworten, die wirklich zu dir passen — jeden Tag, in deinem Tempo.",
    chatSubtitle: "Dein AYU — immer für dich da",
    chatFeature1Title: "Personalisierte Antworten",
    chatFeature1Text: "Basierend auf deinem Phänotyp erhältst du Empfehlungen, die wirklich zu dir passen — keine generischen Tipps.",
    chatFeature2Title: "Ernährung & Routinen",
    chatFeature2Text: "Frag nach Mahlzeiten, Morgenroutinen oder Abendrituale — AYU kennt deinen Typ und deine Bedürfnisse.",
    chatFeature3Title: "Gesundheitstagebuch",
    chatFeature3Text: "Halte fest, wie du dich fühlst. Über die Zeit erkennt AYU Muster und hilft dir, deine Balance zu finden.",
    chatFeature4Title: "24/7 verfügbar",
    chatFeature4Text: "Dein persönlicher Gesundheitsbegleiter ist immer da — morgens beim Frühstück oder abends vor dem Schlafen.",
    chatCompanion: "Dein Gesundheitsbegleiter",
    chatMsg1Date: "Mittwoch, 5. März",
    chatMsg1User: "Ich fühle mich seit Tagen aufgebläht und habe kaum Energie. Was kann ich tun?",
    chatMsg1Bot: "Guten Morgen! Basierend auf deinem Phänotyp empfehle ich dir heute warme, erdende Speisen. Starte den Tag mit einem warmen Hafer- oder Reisbrei, verfeinert mit Gewürzen wie Kurkuma und Ingwer.",
    chatMsg2User: "Was sollte ich zum Mittag essen?",
    chatMsg2Bot: "Integriere gedünstetes Gemüse (wie Wurzelgemüse) und leichte Suppen. Vermeide Rohkost und kalte Getränke. Deine Mittagsmahlzeit sollte die größte des Tages sein.",
    chatMsg3User: "Und was ist mit Bewegung?",
    chatMsg3Bot: "Deine Morgenroutine sollte sanfte Bewegungen und ein Glas warmes Wasser mit Zitrone beinhalten. Versuche 15 Minuten Pranayama (Atemübungen) und einen kurzen Spaziergang nach dem Mittagessen. Bleib gesund!",
    chatInputPlaceholder: "Frag mich etwas...",
    readyTitle1: "Bereit, deinen Körper",
    readyTitle2: "zu verstehen?",
    readyDesc: "In dieser kurzen Einführung entdeckst du, wie AYU ganzheitliche Gesundheit auf eine personalisierte und praktische Weise unterstützt.",
    readyTag1: "Ca. 10 Minuten",
    readyTag2: "Kostenlos",
    readyTag3: "Keine Diagnose",
    nextTitle: "Bereit für den nächsten Schritt?",
    nextDesc: "Starte jetzt deine persönliche AYU Journey — kostenlos und unverbindlich.",
    nextCardTitle: "Deine AYU Journey starten",
    nextCardDesc: "Erhalte sofortigen Zugang zu deinem personalisierten Gesundheitsplan — basierend auf 5.000 Jahren Ayurveda-Weisheit und deiner einzigartigen Konstitution.",
    nextContact: "Schreib uns jederzeit.",
    footerStartseite: "Startseite",
    footerImpressum: "Impressum",
    footerDatenschutz: "Datenschutz",
    inlineCta1Text: "Bereit, deinen Körper zu verstehen?",
    inlineCta1Button: "Jetzt kostenlos starten",
    inlineCta2Text: "In nur 3 Schritten zu deinem Plan",
    inlineCta2Button: "Assessment starten",
    inlineCta3Text: "Finde deinen Weg zu mehr Balance",
    inlineCta3Button: "Jetzt entdecken",
    inlineCta4Text: "Über 180.000 Menschen vertrauen AYU",
    inlineCta4Button: "Kostenlos starten",
  },

  buch: {
    navConsultation: "Beratung buchen",
    navBuy: "Jetzt kaufen",
    heroBadge: "Das Buch von Annam & Christopher",
    heroStarRating: "Leser-Bewertungen",
    heroFormatLabel: "Format",
    heroEbookTitle: "E-Book (PDF)",
    heroEbookSub: "Sofort-Download",
    heroPrintTitle: "Print-Buch",
    heroPrintSub: "Versand nach Hause",
    heroVatNote: "inkl. MwSt.",
    heroBuyButton: "Jetzt kaufen",
    heroBadgePayment: "Sichere Zahlung via Stripe",
    heroBadgeDownload: "Sofortiger Download",
    heroBadgeShipping: "Versand in 3-5 Tagen",
    beschreibungBadge: "Warum dieses Buch?",
    beschreibungTitle1: "Warum die Alpen nicht Kerala sind",
    beschreibungTitle2: "Ayurveda neu gedacht",
    beschreibungP1: "Ayurveda bedeutet nicht, eine endlose Liste an Rezepten und Tipps blind zu befolgen. Es bedeutet, den Menschen im Kontext seiner Umwelt zu verstehen – mit Ort, Zeit und Konstitution als entscheidende Faktoren.",
    beschreibungP2: "Doch Europa, Nordamerika und Australien sind nicht Indien. Unterschiedliches Klima, Ernährung, Kultur und Genetik verändern, wie Empfehlungen wirken – was dort heilt, kann hier belasten.",
    beschreibungP3: "Der AYU-Ansatz übersetzt diese Unterschiede in zwölf funktionelle Menschentypen. Sie sind keine Frage der Herkunft, sondern von Reaktion und Muster. Jeder Mensch – ob in Hamburg, New York, Toronto oder Sydney – findet sich in ihnen wieder.",
    beschreibungP4: "Das Ergebnis: ein Ayurveda, das wirklich wirkt. Maßgeschneidert, präventiv und praktisch. Ein Schlüssel zu echter Gesundheit im 21. Jahrhundert.",
    kapitelBadge: "Was dich erwartet",
    kapitelTitle1: "Die Kernthemen des",
    kapitelTitle2: "Buches",
    kapitel1Title: "Warum die Alpen nicht Kerala sind",
    kapitel1Desc: "Ayurveda neu gedacht im westlichen Kontext",
    kapitel2Title: "12 funktionelle Menschentypen",
    kapitel2Desc: "Keine Frage der Herkunft, sondern von Reaktion und Muster",
    kapitel3Title: "Klima, Kultur & Genetik",
    kapitel3Desc: "Wie Umweltfaktoren Empfehlungen verändern",
    kapitel4Title: "Ayurveda, das wirklich wirkt",
    kapitel4Desc: "Maßgeschneidert, präventiv und praktisch",
    autorenBadge: "Die Autoren",
    autorenTitle: "Hanfstein",
    autorenAnnam: "inspiriert mit Ayurveda über 180.000 Menschen. Aus einer Heiler-Dynastie stammend, lebt sie das Wissen, das sie seit Kindheit begleitet – praxisnah, alltagstauglich und voller Lebenskraft.",
    autorenChristopher: "ist Gesundheitsstratege und Gründer von GENOpuzzle.com. Mit tiefer Erfahrung im Gesundheitssystem verbindet er alte Weisheit mit moderner Technologie, um Prävention neu zu denken.",
    autorenTogether: "Gemeinsam bringen sie Ayurveda in eine neue Zeit – als Symbiose aus Tradition und Innovation, zugänglich für alle.",
    reviewsBadge: "Leser-Stimmen",
    reviewsTitle1: "Was unsere",
    reviewsTitle2: "Leser sagen",
    review1Text: "Dieses Buch hat meine Sichtweise auf Ayurveda komplett verändert. Endlich ein Ansatz, der in Europa funktioniert.",
    review2Text: "Wissenschaftlich fundiert und trotzdem verständlich. Ein Muss für jeden, der sich für ganzheitliche Gesundheit interessiert.",
    review3Text: "Annam und Christopher verbinden altes Wissen mit moderner Wissenschaft auf eine einzigartige Weise.",
    kaufenBadge: "Jetzt bestellen",
    kaufenTitle: "Dein Exemplar von",
    kaufenDesc: "Erhältlich als E-Book (PDF) zum Sofort-Download oder als hochwertiges Print-Buch – in Deutsch und Englisch.",
    ebookTitle: "E-Book (PDF)",
    ebookSub: "Sofort-Download nach Kauf",
    ebookFeature1: "Sofortiger Download als PDF",
    ebookFeature2: "Auf allen Geräten lesbar",
    ebookFeature3: "Deutsch & Englisch verfügbar",
    ebookFeature4: "Druckbar für persönlichen Gebrauch",
    ebookLangDe: "Deutsch",
    ebookLangEn: "English",
    ebookBuyButton: "E-Book kaufen",
    printTitle: "Print-Buch",
    printSub: "Versand nach Hause",
    printFeature1: "Hochwertiger Druck",
    printFeature2: "Versand in 3-5 Werktagen",
    printFeature3: "Perfekt zum Verschenken",
    printFeature4: "Deutsch (Print-Ausgabe)",
    printBuyButton: "Print-Buch bestellen",
    trustPayment: "Sichere Zahlung via Stripe",
    trustDownload: "Sofort-Download nach Kauf",
    trustGlobal: "Weltweit verfügbar",
    finalTitle1: "Bereit für ein Ayurveda, das",
    finalTitle2: "wirklich funktioniert",
    finalDesc: "Entdecke, warum traditionelles Ayurveda in Europa angepasst werden muss – und wie der AYU-Ansatz dir den Weg zu echter Gesundheit zeigt.",
    finalBuyButton: "Buch jetzt bestellen",
    finalConsultButton: "Kostenloses Beratungsgespräch",
    footerCopyright: "Alle Rechte vorbehalten.",
    footerHome: "Startseite",
    footerConsultation: "Beratung",
    footerOffer: "Angebot",
  },
} as const;

export default de;
